import { DataProps } from '../pages/NewCollectionsPage/NewCollectionPage.types'
import {
  selectionImages,
  selectionImagesTop,
  thematicImages,
  thematicImages14,
  thematicImages16,
  thematicImages17,
  thematicImages25,
  thematicImages28,
  thematicImages38,
  // thematicImages45,
  thematicImages48,
  thematicImages52,
  thematicImages57,
  thematicImages58,
  thematicImages62,
  thematicImages64,
  thematicImages65,
  thematicImages68,
  thematicImages73,
  thematicImages76,
} from './collectionPage'

export const collectionsData: { collections: DataProps[] } = {
  collections: [
    {
      id: '1',
      about: {
        title: 'Квартиры в готовых проектах',
        text: 'Жилье в сданных проектах, где уже есть инфраструктура для жизни',
        imagePath: selectionImages['1'],
      },
      profit: {
        title: 'Почему \nэто выгодно',
        text: 'При покупке квартиры в готовом доме есть возможность не только быстро заселиться, но и получить сложившуюся и современную инфраструктуру. Новому жителю сразу будут доступны магазины, кафе и другие сервисы в пределах района.',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Подборка квартир в готовых проектах',
      },
      disable: true,
    },
    {
      id: '2',
      about: {
        title: 'Семейный топ: подборка больших квартир',
        text: 'Квартиры, которые подойдут для большой семьи и любителей простора',
        imagePath: selectionImages['2'],
      },
      profit: {
        title: 'Почему \nэто интересно',
        text:
          'Студии есть у любого застройщика, а вот большие и хорошо спланированные ' +
          'квартиры — не такое уж частое предложение на рынке новостроек.',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Подборка квартир от 90 м²',
      },
      noMetro: true,
      disable: true,
    },
    {
      id: '3',
      about: {
        title: 'Без машины \nкуда угодно',
        text: 'Квартиры в проектах, расположенные в 15 минутах пешком от метро',
        imagePath: selectionImages['3'],
      },
      profit: {
        title: 'Почему \nэто выгодно',
        text: 'Квартира у метро - это возможность доехать до любого района без пробок и ожиданий. Это позволяет планировать и экономить время, а ещё такие квартиры всегда будут пользоваться спросом',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Квартиры рядом с метро',
      },
      disable: true,
    },
    {
      id: '4',
      category: 'infrastructure',
      anonce: {
        title: 'Квартиры в проектах с PlayHub и LocalPlay',
        lead: 'Место для игры и отдыха',
        anchorName: 'Квартиры в проектах с PlayHub и LocalPlay',
        imagePath: selectionImages['4'],
      },
      about: {
        title: 'Квартиры в проектах с PlayHub и LocalPlay',
        text: 'Кварталы, где есть не просто детские площадки, а Playhub и LocalPlay - место для игры и отдыха',
        imagePath: selectionImages['4'],
      },
      profit: {
        title: 'Почему \nэто выгодно',
        text: 'Playhub — новая концепция игрового пространства и место для встреч и общения. Детям оно помогает социализироваться и творчески развиваться, а взрослым — формировать дружное сообщество жителей.',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Место для игры и отдыха\n',
      },
    },
    {
      id: '5',
      category: 'popular',
      anonce: {
        title: 'Квартиры с французскими балконами',
        lead: 'Дом, где всегда много света',
        anchorName: 'Квартиры с французскими балконами',
        imagePath: selectionImages['5'],
      },
      about: {
        title: 'Квартиры с французскими балконами',
        text: 'Благодаря панорамному остеклению здесь всегда много света',
        imagePath: selectionImages['5'],
      },
      profit: {
        title: 'Почему \nэто выгодно',
        text: 'Панорамное остекление дает больше воздуха в пространстве и хороший уровень освещения. Это особенно важно, если вы любите светлые помещения или комната находится на теневой стороне.',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Квартиры с окнами в пол',
      },
    },
    {
      id: '6',
      // category: 'infrastructure',
      anonce: {
        title: 'Дома рядом с вузами',
        lead: 'Дорога займет не больше 30 минут',
        anchorName: 'Дома рядом с вузами',
        imagePath: selectionImages['6'],
      },
      about: {
        title: 'Дома рядом с вузами',
        text: 'Проекты, из которых удобно добираться до учебы — дорога займет не больше 30 минут ',
        imagePath: selectionImages['6'],
      },
      profit: {
        title: 'Почему это интересно',
        text: 'В домах ПИК большой выбор планировок под разные сценарии. Например, молодой семье с будущим абитуриентом или как свое первое жилье для студента. А районы вблизи университетов традиционно лидируют в рейтингах недвижимости.',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Проекты рядом с вузами',
      },
    },
    {
      id: '7',
      category: 'popular',
      anonce: {
        title: 'Квартиры с высокими потолками',
        lead: 'Всё о высоких потолках',
        anchorName: 'Квартиры с высокими потолками',
        imagePath: selectionImages['7'],
      },
      about: {
        title: 'Квартиры с высокими потолками',
        text: 'Высокие потолки делают квартиру визуально больше. А еще можно сделать второй ярус.',
        imagePath: selectionImages['7'],
      },
      profit: {
        title: 'Почему это интересно',
        text: 'Высокие потолки дают простор для дизайнерских решений и позволяют функционально использовать пространство. Например, сделать места для хранения вещей или второй уровень под спальню и кабинет.',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Квартиры с потолками от 4-х метров',
      },
      noMetro: true,
    },
    {
      id: '8',
      about: {
        title: 'Квартиры рядом с парками',
        text: 'Уникальная возможность жить в городе и не разрывать связь с природой',
        imagePath: selectionImages['8'],
      },
      profit: {
        title: 'Почему это интересно',
        text: 'Если живете рядом с парком, можно практически в любой момент прогуляться в тени деревьев или устроить семейный пикник. При этом близость с природой удачно сочетается с возможностью без труда поехать по делам в центр.',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Квартиры рядом с парками',
      },
      disable: true,
    },
    {
      id: '9',
      category: 'location',
      anonce: {
        title: 'Жизнь на западе Москвы',
        lead: 'Жизнь в престижном районе',
        anchorName: 'Жизнь на западе Москвы',
        imagePath: selectionImages['9'],
      },
      about: {
        title: 'Жизнь на западе Москвы',
        text: 'Районы на западе традиционно являются престижными, с хорошей экологией и парками',
        imagePath: selectionImages['9'],
      },
      profit: {
        title: 'Почему это интересно',
        text: 'Районы на западе столицы одни из самых экологически чистых: мало предприятий, много парков, а благодаря розе ветров — чистый воздух. Также здесь много исторических и интересных мест.',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Жизнь на западе Москвы',
      },
    },
    {
      id: '10',
      // category: 'location',
      anonce: {
        title: 'Шопинг и развлечения рядом',
        lead: 'Квартиры около ТРЦ',
        anchorName: 'Шопинг и развлечения рядом',
        imagePath: selectionImages['10'],
      },
      about: {
        title: 'Кварталы рядом с торговыми центрами',
        text: 'Магазины, кафе, различные сервисы, услуги и развлечения рядом с домом',
        imagePath: selectionImages['10'],
      },
      profit: {
        title: 'Почему это интересно',
        text: 'Сходить в кино, отдать костюм в химчистку или развеяться за семейным шопингом — всё это можно сделать в крупных торговых центрах. Тем, кто ценит возможность развлечься и решить все дела разом, жизнь рядом с ТРЦ особенно придётся по вкусу.',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Проекты рядом с ТРЦ',
      },
    },
    {
      id: '11',
      about: {
        title: 'Коммерческие помещения в готовых домах',
        text: 'Отличный вариант для дохода от сдачи в аренду или первый шаг к своему бизнесу',
        imagePath: selectionImages['11'],
      },
      profit: {
        title: 'Почему это интересно',
        text: 'Помещения на первых этажах находятся в уже готовых проектах — а значит, рядом с коммерческим помещением уже живут потенциальные клиенты вашего будущего кафе или барбершопа. Также такие помещения привлекательны для сдачи в аренду.',
        color: '#E3D3F7',
      },
      thematicContent: [
        {
          title: 'Оранж парк',
          image: thematicImages['1'],
          text: 'Жилой квартал «Оранж парк» расположен в городе Котельники. Отсюда до метро - всего 3 минуты пешком. Более 300 тыс. кв.м сданного жилья дадут бизнесу мощный локальный трафик, а близость к метро — дополнительную привлекательность для арендаторов и клиентов.',
          url: 'https://www.pik.ru/business/search/park?utm_source=rbc&utm_medium=display&utm_content=commercial ',
        },
        {
          title: 'Второй Нагатинский',
          image: thematicImages['2'],
          text: 'Жилой квартал расположен в районе Нагатино-Садовники, в 15 минутах ходьбы от метро «Нагатинская» и в 18 минутах от «Коломенской». В жилом квартале будет семнадцать домов высотой от 17 до 33 этажей — два дома уже сданы. В них большой выбор коммерческих помещений с витринными окнами.',
          url: 'https://www.pik.ru/business/search/2ngt?utm_source=rbc&utm_medium=display&utm_content=commercial',
        },
        {
          title: 'Люблинский парк',
          image: thematicImages['3'],
          text: 'Жилой квартал «Люблинский парк» расположен на юго-востоке Москвы, в шаговой доступности от станции «Братиславская» и недалеко от станция МЦД «Перерва». В проекте 54 жилых корпуса — тысячи потенциальных клиентов для новых бизнесов.',
          url: 'https://www.pik.ru/business/search/lublinpark?utm_source=rbc&utm_medium=display&utm_content=commercial',
        },
        {
          title: 'Мякинино парк',
          image: thematicImages['4'],
          text: '«Мякинино парк» возводится на западе Москвы, в двух километрах от МКАД. Рядом с проектом нет другой жилой застройки. Жители будут покупать продукты, пить кофе, стричься и делать маникюр исключительно в пределах своего квартала. Хороший вариант для первой инвестиции.',
          url: 'https://www.pik.ru/business/search/myakinino?utm_source=rbc&utm_medium=display&utm_content=commercial',
        },
        {
          title: 'Большая Очаковская 2',
          image: thematicImages['5'],
          text: 'Проект «Большая Очаковская 2» расположен на западе Москвы, в 8 минутах ходьбы от станции метро «Аминьевская». Четыре из шести корпусов уже сданы — это пока свободные коммерческие площади в быстро строящемся районе.',
          url: 'https://www.pik.ru/business/search/bo2?utm_source=rbc&utm_medium=display&utm_content=commercial',
        },
        {
          title: 'Бунинские луга',
          image: thematicImages['6'],
          text: '«Бунинские луга« расположены в Новой Москве, в 7 км от МКАД, рядом с прудами и парками. До станции метро «Бунинские аллеи» — 20 минут пешком, до «Коммунарки» —10 минут на автомобиле. Это один из крупнейших кварталов ПИК — больше миллиона квадратных метров жилья.',
          url: 'https://www.pik.ru/business/search/luga?utm_source=rbc&utm_medium=display&utm_content=commercial',
        },
      ],
      disable: true,
    },
    {
      id: '12',
      about: {
        title: 'Проекты в Новой Москве',
        text: 'Для тех, кто мечтает жить на природе и удобно добираться на работу',
        imagePath: selectionImages['12'],
      },
      profit: {
        title: 'Почему это интересно',
        text: 'Новая Москва подходит тем, кто мечтает жить ближе к природе и не отказываться от преимуществ большого города. Здесь свежая среда, несоветские мастерпланы, немного народу, а ещё — отличный баланс цены и качества для новостроек.',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Проекты в Новой Москве',
      },
      disable: true,
    },
    {
      id: '13',
      category: 'infrastructure',
      anonce: {
        title: 'Проекты с футбольным полем',
        lead: 'Настоящие матчи во дворе дома',
        anchorName: 'Проекты с футбольным полем',
        imagePath: selectionImages['13'],
      },
      about: {
        title: 'Проекты с футбольным полем',
        text: 'Играйте в футбол рядом с домом и приглашайте друзей и знакомых',
        imagePath: selectionImages['13'],
      },
      profit: {
        title: 'Почему это интересно',
        text: 'Играйте рядом с домом и приглашайте друзей и знакомых. Не надо никуда ездить — такие спортивные площадки есть почти во всех проектах ПИК.',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Проекты с футбольным полем',
      },
    },
    {
      id: '14',
      category: 'location',
      anonce: {
        title: 'Апартаменты «Вольта»',
        lead: 'Недвижимость для инвестиций',
        anchorName: 'Апартаменты «Вольта»',
        imagePath: selectionImages['14'],
      },
      about: {
        title: 'Сервисные апартаменты «Вольта»',
        text: 'Сервисные апартаменты — отличный вариант для дохода от сдачи в аренду',
        imagePath: selectionImages['14'],
      },
      profit: {
        title: 'Почему это выгодно',
        text: 'Сервисные апартаменты — один из самых удобных способов получать пассивный доход от сдачи недвижимости в аренду: управляющая компания сама ищет арендаторов и производит расчёты. Инвестиции буквально будут работать на вас с первого дня.',
        color: '#e4f0d5',
      },
      thematicContent: [
        {
          title: 'Что такое сервисные апартаменты',
          image: thematicImages14['1'],
          text: 'Апартаменты «Вольта» предназначены как для собственного непродолжительного проживания в Санкт-Петербурге, например, во время отпуска или частых командировок, так и для инвестиций. Это один из самых удобных способов получать доход от сдачи недвижимости в аренду на любой срок: управляющая компания сама ищет арендаторов и производит расчёты.',
          url: 'https://www.pik.ru/spb/volta?utm_source=rbc&utm_medium=display&utm_content=volta',
          buttonName: 'Смотреть апартаменты «Вольта»',
        },
        {
          title: 'Программы доходности*',
          image: thematicImages14['2'],
          text: 'ПИК предлагает три программы доходности апартаментов – от 57 тыс. до 79 тыс. руб. в месяц. Расчёт возможного дохода является ориентировочным при посуточной сдаче апартаментов через управляющую компанию. При расчёте возможного дохода не учтены затраты на меблировку, технику, дополнительные платежи и расходы. Доход зависит от площади и состояния апартаментов, рыночной ситуации и иных факторов.',
          url: 'https://www.pik.ru/spb/volta?utm_source=rbc&utm_medium=display&utm_content=volta',
          buttonName: 'Смотреть апартаменты «Вольта»',
        },
        {
          title: 'Особенности проекта Вольта',
          image: thematicImages14['3'],
          text: '«Вольта» расположена в Санкт-Петербурге на набережной реки Охты, в 8 минутах ходьбы от метро «Ладожская». В 15-этажном здании будет 430 апартаментов с готовой отделкой. В сервисных апартаментах предусмотрены удобства: ресторан, лобби с ресепшен 24/7, химчистка, прачечная, клининг, доставка продуктов, консьерж-сервис. Для автомобилей предусмотрена парковка и подземный паркинг.',
          url: 'https://www.pik.ru/spb/volta?utm_source=rbc&utm_medium=display&utm_content=volta',
          buttonName: 'Смотреть апартаменты «Вольта»',
        },
        {
          title: 'Планировки',
          image: thematicImages14['4'],
          text: 'В проекте «Вольта» на выбор доступны апартаменты с готовой дизайнерской отделкой площадью от 19 до 39 кв. м. Высота потолков — 2,61 метра. С верхних этажей открывается панорамный вид на реку Охту и город.',
          url: 'https://www.pik.ru/spb/volta?utm_source=rbc&utm_medium=display&utm_content=volta',
          buttonName: 'Смотреть апартаменты «Вольта»',
        },
      ],
      footnote:
        '*Расчёт возможного дохода является ориентировочным при посуточной сдаче апартаментов через Управляющую компанию «МТЛ» (УК). При расчёте возможного дохода не учтены дополнительные затраты на пакет меблировки и техники, иные дополнительные платежи и расходы, включая обязательные налоги и сборы. Возможный доход зависит от площади и состояния апартаментов, рыночной ситуации и иных факторов, действующих на день размещения информации на сайте. Указанный возможный доход в рублях рассчитан и формируется из суммы броней апартаментов за календарный месяц (которую аккумулирует УК), из которой вычитается вознаграждение УК, страховые взносы, коммунальные платежи и прочие расходы на содержание апартаментов. Любая информация, представленная на данном сайте, носит исключительно информационный характер и ни при каких условиях не является публичной офертой, определяемой положениями статьи 437 ГК РФ.',
    },
    {
      id: '15',
      category: 'infrastructure',
      anonce: {
        title: 'Проекты рядом с пляжами',
        lead: 'Для любителей отдыха у воды',
        anchorName: 'Проекты рядом с пляжами',
        imagePath: selectionImages['15'],
      },
      about: {
        title: 'Проекты рядом с пляжами',
        text: 'Квартиры рядом с пляжами подойдут для любителей воды и прибрежного отдыха',
        imagePath: selectionImages['15'],
      },
      profit: {
        title: 'Почему это интересно',
        text: 'В Москве не сказать, что много пляжей, а новостроек рядом с ними — ещё меньше. Поэтому возможность позагорать, поиграть в волейбол или понастроить замки из песка поблизости от своей современной квартиры — редкий летний бонус.',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Проекты рядом с пляжами',
      },
    },
    {
      id: '16',
      about: {
        title: 'Самые спортивные кварталы ПИК ',
        text: 'Открытые тренировки для всех желающих',
        video: {
          src: '/videos/collection16/desktop/1.m3u8',
        },
      },
      profit: {
        title: 'Почему это интересно',
        text: (
          <>
            Жители 40 жилых районов Москвы и Подмосковья занимаются спортом
            благодаря проекту ПИК-Спорт. Любой может записаться на тренировки{' '}
            {
              <a href='https://t.me/piksportbot' target='_blank'>
                через чат-бот в Telegram
              </a>
            }
            . И, самое главное, формат посещений — свободный.
          </>
        ),
        color: '#e4f0d5',
      },
      thematicContent: [
        {
          title: '«Бунинские луга»',
          image: thematicImages16['1'],
          text: (
            <>
              &laquo;Бунинские луга&raquo; расположены в&nbsp;Новой Москве,
              в&nbsp;7&nbsp;км от&nbsp;МКАД, рядом с&nbsp;прудами
              и&nbsp;парками. До&nbsp;станции метро &laquo;Бунинские
              аллеи&raquo;&nbsp;&mdash; 20&nbsp;минут пешком,
              до&nbsp;&laquo;Коммунарки&raquo; &mdash;10 минут
              на&nbsp;автомобиле. Это один из&nbsp;крупнейших кварталов
              ПИК&nbsp;&mdash; больше миллиона квадратных метров жилья. Здесь
              есть тренировки по&nbsp;бегу, ОФП, футболу, баскетболу, воркауту,
              боксу, йоге и&nbsp;физкультуре для детей.
            </>
          ),
          url: 'https://www.pik.ru/luga?utm_source=rbc&utm_medium=display&utm_content=sport',
          buttonName: 'Подробнее о проекте',
        },
        {
          title: 'Green park',
          image: thematicImages16['2'],
          text: (
            <>
              Жилой квартал Green park находится недалеко от&nbsp;станций метро
              &laquo;Ботанический сад&raquo; и&nbsp;&laquo;Отрадное&raquo;.
              В&nbsp;квартале проходят спортивные занятия по&nbsp;бегу, ОФП,
              футболу и&nbsp;баскетболу.
            </>
          ),
          url: 'https://www.pik.ru/gp?utm_source=rbc&utm_medium=display&utm_content=sport',
          buttonName: 'Подробнее о проекте',
        },
        {
          title: '«Саларьево парк»',
          image: thematicImages16['3'],
          text: (
            <>
              &laquo;Саларьево парк&raquo; расположен в&nbsp;Новой Москве,
              в&nbsp;четырёх километрах от&nbsp;МКАД по&nbsp;Киевскому шоссе.
              К&nbsp;жилому кварталу примыкают две станции метро:
              &laquo;Саларьево&raquo; с&nbsp;одной стороны и&nbsp;&laquo;Филатов
              Луг&raquo; с&nbsp;другой. Поблизости Ульяновский парк и&nbsp;парк
              &laquo;Филатов Луг&raquo;. Здесь занимаются бегом, воркаутом,
              йогой, ОФП, а&nbsp;ещё играют в&nbsp;футбол и&nbsp;баскетбол. Есть
              физкультура для детей.
            </>
          ),
          url: 'https://www.pik.ru/sp?utm_source=rbc&utm_medium=display&utm_content=sport',
          buttonName: 'Подробнее о проекте',
        },
        {
          title: '«Ясеневая 14»',
          image: thematicImages16['4'],
          text: (
            <>
              Жилой квартал &laquo;Ясеневая&nbsp;14&raquo; расположен
              в&nbsp;хорошо развитом районе на&nbsp;юге Москвы.
              За&nbsp;10&nbsp;минут можно доехать до&nbsp;парка Царицыно,
              а&nbsp;за&nbsp;25&nbsp;&mdash; до&nbsp;аэропорта
              &laquo;Домодедово&raquo;. Удобный выезд на&nbsp;МКАД
              и&nbsp;на&nbsp;Каширское шоссе. В&nbsp;квартале проходят
              спортивные занятия по&nbsp;бегу, ОФП и&nbsp;физкультуре для детей.
            </>
          ),
          url: 'https://www.pik.ru/pages/sport?utm_source=rbc&utm_medium=display&utm_content=sport_yasenevaya',
          buttonName: 'Подробнее о ПИК-Спорт',
        },
        {
          title: '«Мещерский лес»',
          image: thematicImages16['5'],
          text: (
            <>
              Жилой район расположен рядом с&nbsp;Мещерским парком,
              в&nbsp;четырех минутах пешком от&nbsp;станции метро
              &laquo;Говорово&raquo;. В&nbsp;пяти минутах ходьбы&nbsp;&mdash;
              станция &laquo;Мещерская&raquo;. В&nbsp;квартале проходят
              спортивные занятия по&nbsp;бегу, ОФП, велоспорту, воркауту
              и&nbsp;йоге.
            </>
          ),
          url: 'https://www.pik.ru/les?utm_source=rbc&utm_medium=display&utm_content=sport',
          buttonName: 'Подробнее о проекте',
        },
        {
          title: '«Одинцово-1»',
          image: thematicImages16['6'],
          text: (
            <>
              Жилой район &laquo;Одинцово-1&raquo; расположен
              в&nbsp;10&nbsp;километрах от&nbsp;МКАД по&nbsp;Минскому шоссе,
              в&nbsp;10&nbsp;минутах езды от&nbsp;станции МЦД
              &laquo;Одинцово&raquo;. В&nbsp;квартале проходят спортивные
              занятия по&nbsp;бегу, ОФП, футболу, баскетболу, йоге
              и&nbsp;физкультуре для детей.
            </>
          ),
          url: 'https://www.pik.ru/odin?utm_source=rbc&utm_medium=display&utm_content=sport',
          buttonName: 'Подробнее о проекте',
        },
        {
          title: '«Академика Павлова»',
          image: thematicImages16['7'],
          text: (
            <>
              &laquo;Академика Павлова&raquo; расположен в&nbsp;экологически
              чистом районе Кунцево. От&nbsp;домов до&nbsp;метро
              &laquo;Молодёжная&raquo;&nbsp;&mdash; всего 7&nbsp;минут пешком.
              Рядом находятся зелёные парки, спортивные клубы, детские сады,
              школы и&nbsp;магазины. В&nbsp;квартале проходят спортивные занятия
              по&nbsp;бегу, ОФП, баскетболу и&nbsp;воркауту.
            </>
          ),
          url: 'https://www.pik.ru/apavlova?utm_source=rbc&utm_medium=display&utm_content=sport',
          buttonName: 'Подробнее о проекте',
        },
        {
          title: '«Дмитровский парк»',
          image: thematicImages16['8'],
          text: (
            <>
              Жилой квартал &laquo;Дмитровский парк&raquo; строится в&nbsp;пяти
              минутах ходьбы от&nbsp;парка &laquo;Ангарские пруды&raquo;.
              До&nbsp;станции метро &laquo;Селигерская&raquo; 20&nbsp;минут
              на&nbsp;общественном транспорте, а&nbsp;в&nbsp;2023 году ближе
              откроются ещё две станции: &laquo;Лианозово&raquo;
              и&nbsp;&laquo;Яхромская&raquo;. В&nbsp;квартале проходят
              спортивные занятия по&nbsp;бегу и&nbsp;ОФП.
            </>
          ),
          url: 'https://www.pik.ru/dp?utm_source=rbc&utm_medium=display&utm_content=sport',
          buttonName: 'Подробнее о проекте',
        },
        {
          title: '«Лефортово парк»',
          image: thematicImages16['9'],
          text: (
            <>
              Жилой квартал &laquo;Лефортово парк&raquo; находится в&nbsp;районе
              Лефортово, в&nbsp;5&nbsp;минутах ходьбы от&nbsp;станции метро
              &laquo;Авиамоторная&raquo;. В&nbsp;квартале проходят тренировки
              по&nbsp;бегу, ОФП, футболу, баскетболу, боксу, а&nbsp;ещё можно
              заняться йогой.
            </>
          ),
          url: 'https://www.pik.ru/pages/sport?utm_source=rbc&utm_medium=display&utm_content=sport_lefortovo',
          buttonName: 'Подробнее о ПИК-Спорт',
        },
        {
          title: 'Vander park',
          image: thematicImages16['10'],
          text: (
            <>
              Жилой комплекс Vander Park, разработанный голландским бюро
              de&nbsp;Architekten Cie., находится на&nbsp;Рублёвском шоссе,
              в&nbsp;пяти минутах пешком от&nbsp;метро &laquo;Молодёжная&raquo;.
              В&nbsp;квартале проходят спортивные занятия по&nbsp;бегу
              и&nbsp;ОФП.
            </>
          ),
          url: 'https://www.pik.ru/pages/sport?utm_source=rbc&utm_medium=display&utm_content=sport_vander',
          buttonName: 'Подробнее о ПИК-Спорт',
        },
      ],
      disable: true,
    },
    {
      id: '17',
      about: {
        title: 'Продуман каждый метр',
        text: 'Квартиры ПИК – функциональное пространство, в котором продуман каждый метр',
        imagePath: selectionImages['17'],
      },
      profit: {
        title: 'Почему это интересно',
        text: 'Квартиры ПИК — это функциональное и гибкое пространство, которое легко настроить под себя. Для каждой планировки мы продумываем все возможные жизненные сценарии, чтобы пространство квартиры дарило максимум комфорта и радости.',
        color: '#E3D3F7',
      },
      thematicContent: [
        {
          title: 'Гостиная, совмещенная с кухней',
          image: thematicImages17['4'],
          text: (
            <>
              Такое решение создаёт пространство, которое легко поддается
              зонированию. Здесь удобно не&nbsp;только готовить,
              но&nbsp;и&nbsp;комфортно работать, делать уроки, отдыхать,
              устраивать вечеринки и&nbsp;проводить время всей семьей.
            </>
          ),
          url: 'https://www.pik.ru/search?attribute=livingKitchen&utm_source=rbc&utm_medium=display&utm_content=planirovki',
          buttonName: 'Смотреть квартиры',
        },
        {
          title: 'Гардеробные',
          image: thematicImages17['3'],
          text: (
            <>
              Гардеробные&nbsp;&mdash; функциональные зоны, которые можно
              обустроить по&nbsp;собственному желанию. Гардеробная освобождает
              остальные комнаты от&nbsp;шкафов и&nbsp;комодов, что делает
              интерьер не&nbsp;перегруженным и&nbsp;более легким. А&nbsp;ещё
              кроме гардероба здесь можно оборудовать уютный кабинет и&nbsp;даже
              мини-спортзал.
            </>
          ),
          url: 'https://www.pik.ru/search?utm_source=rbc&utm_medium=display&utm_content=planirovki',
          buttonName: 'Смотреть квартиры',
        },
        {
          title: 'С дополнительной ванной комнатой',
          image: thematicImages17['2'],
          text: (
            <>
              В&nbsp;квартирах с&nbsp;двумя санузлами жизнь становится
              проще&nbsp;&mdash; можно быстрее собраться в&nbsp;школу или
              на&nbsp;работу, а&nbsp;вечером спокойно насладиться расслабляющими
              процедурами. Если у&nbsp;вас большая семья, то&nbsp;такая квартира
              позволит жить с&nbsp;удобством, пользуясь санузлами в&nbsp;любое
              время и&nbsp;не&nbsp;стучась в&nbsp;дверь, пока домочадцы
              не&nbsp;освободят комнату. Если семья небольшая, то&nbsp;можно
              организовать гостевой туалет.
            </>
          ),
          url: 'https://www.pik.ru/search?attribute=bath&utm_source=rbc&utm_medium=display&utm_content=planirovki',
          buttonName: 'Смотреть квартиры',
        },
        {
          title: 'Балконы и лоджии',
          image: thematicImages17['1'],
          text: (
            <>
              Сейчас балконы получают особую ценность, в том числе для
              работающих на удаленке. Балконы и лоджии можно использовать, как
              летнюю террасу, сделать там мини-кабинет, поставить любимые цветы
              или наслаждаться утренней чашкой кофе на свежем воздухе.
            </>
          ),
          url: 'https://www.pik.ru/search?attribute=balcony&utm_source=rbc&utm_medium=display&utm_content=planirovki',
          buttonName: 'Смотреть квартиры',
        },
      ],
      disable: true,
    },
    {
      id: '18',
      about: {
        title: 'Квартиры с 2 санузлами',
        text: 'Для спокойного утра в семье',
        imagePath: selectionImages['18'],
      },
      profit: {
        title: 'Почему это интересно',
        text: 'Жизнь большой семьи в квартирах с двумя санузлами становится проще — утром быстрее собираться в школу или на работу, а вечером можно спокойно принять ванну. А ещё это отличный вариант для организации гостевого туалета.',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Проекты c дополнительной ванной комнатой',
      },
      noMetro: true,
      disable: true,
    },
    {
      id: '19',
      category: 'popular',
      anonce: {
        title: 'Квартиры с отделкой',
        lead: 'В уже готовых проектах',
        anchorName: 'Готовые квартиры',
        imagePath: selectionImages['19'],
      },
      about: {
        title: 'Всё включено: квартиры с отделкой',
        text: 'Пропускаем стадию ремонта, распаковываем коробки и принимаем гостей. Лайфхак!',
        imagePath: selectionImages['19'],
      },
      profit: {
        title: 'Почему это выгодно',
        text: 'Получили ключи — и сразу переехали в готовый дом. Не нужно терпеть этап с ремонтом, а можно сразу занести кота, расставить мебель и встречать гостей. Или в тот же день сдать квартиру в аренду — никакой упущенной выгоды.',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Готовые квартиры с отделкой',
      },
      linkLastCard:
        'https://www.pik.ru/search/finish/ready?projects=1&utm_source=rbc',
    },
    {
      id: '20',
      about: {
        title: (
          <>
            Жизнь на высоте: <br />
            30-й этаж — не предел
          </>
        ),
        text: 'Небоскрёб по-домашнему: квартиры на 30 этаже и даже выше.',
        imagePath: selectionImages['20'],
      },
      profit: {
        title: 'Почему это интересно',
        text: 'Завтрак с панорамным видом на город — когда живёте на 30 этаже и выше, такое описание означает совсем не то же самое, что завтрак на 10 и даже 20 этаже. А ещё чем выше, тем живописнее и, кстати, тише: шум с земли вас почти не достигает.',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Высотки от 30 этажей',
      },
      disable: true,
    },
    {
      id: '21',
      category: 'location',
      anonce: {
        title: 'Самые зеленые проекты ПИК',
        lead: 'Проекты рядом с лесами и парками',
        anchorName: 'Самые зеленые проекты ПИК',
        imagePath: selectionImages['21'],
      },
      about: {
        title: 'Квартиры в экологически чистых районах',
        text: 'Жить в районе, где чистый воздух, парки и нет вредных предприятий',
        imagePath: selectionImages['21'],
      },
      profit: {
        title: 'Почему это полезно',
        text: 'Город-сад — архитектурная утопия начала XX века, но утопия исключительно приятная. В наше время есть проекты вроде кварталов ПИК, которые не сравнимы с ней по масштабам, но близки в плане зеленого каркаса и грамотного проектирования среды.',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Самые зеленые проекты ПИК',
      },
    },
    {
      id: '22',
      about: {
        title: 'Проекты с новыми школами и детсадами',
        text: 'Жить в благоустроенном районе, где новые школы и детские сады находятся рядом с домом',
        imagePath: selectionImages['22'],
      },
      profit: {
        title: 'Почему это интересно',
        text: 'В сентябре 2023-го в Москве и области открываются 16 новых образовательных учреждений на 8500 детей, построенные ПИК. В своих жилых кварталах компания возвела уже 31 школу и 88 детских садов.',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Новые школы и детсады',
      },
      disable: true,
    },
    {
      id: '23',
      about: {
        title: 'Проекты Матвеевского кластера',
        text: 'Можно наслаждаться комфортной жизнью, не тратя времени на поездки в другие районы.',
        imagePath: selectionImages['23'],
      },
      profit: {
        title: 'Почему это выгодно',
        text: 'В кластер входят «Новое Очаково», «Большая Очаковская 2», Vangarden и «Матвеевский парк». Здесь есть все: инфраструктура и благоустройство позволят наслаждаться комфортной жизнью, не тратя времени на поездки в другие районы.',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Проекты Матвеевского кластера',
      },
      disable: true,
    },
    {
      id: '24',
      about: {
        title: 'Доступные квартиры в пределах МКАД',
        text: 'Есть миф, что бюджетные квартиры далеко за МКАД. Составили подборку-опровержение',
        imagePath: selectionImages['24'],
      },
      profit: {
        title: 'Почему это выгодно',
        text: 'В Москве довольно много доступных по цене квартир — и это не Новая Москва, не вторичное жильё и не исключительно крохотные студии. Это новостройки ПИК, которые отлично подходят для переезда в Москву, сдачи в аренду и даже инвестиций.',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Доступные квартиры в пределах МКАД',
      },
      disable: true,
    },
    {
      id: '25',
      about: {
        title: 'Проекты ПИК+',
        text: 'Проекты с индивидуальной архитектурой, готовой отделкой и уникальными планировками квартир',
        imagePath: selectionImages['25'],
      },
      profit: {
        title: 'Почему это интересно',
        text: 'ПИК+ — это линейка проектов, в которых собраны лучшие решения — от архитектуры до технологий строительства. У каждого проекта линейки свой уникальный архитектурный облик, который прорабатывается совместно с ведущими бюро.',
        color: '#e5e2df',
      },
      thematicContent: [
        {
          title: 'Индивидуальная архитектура',
          image: thematicImages25['1'],
          text: (
            <>
              Архитектура каждого проекта линейки ПИК+ яркая и&nbsp;уникальная:
              фактурные фасады, эркеры, террасы, галереи и&nbsp;угловые балконы.
              Первые этажи создают так называемый city level&nbsp;&mdash; уютное
              пространство для прогулок и&nbsp;шопинга прямо у&nbsp;дома. Для
              проектирования часто приглашают известные международные бюро.
            </>
          ),
          url: 'https://www.pik.ru/plus?utm_source=rbc&utm_medium=display&utm_content=plus',
          buttonName: 'Узнать больше',
        },
        {
          title: 'Функциональные квартиры и готовая отделка',
          image: thematicImages25['2'],
          text: (
            <>
              Благодаря архитекторам и&nbsp;инженерам квартиры теперь ещё
              функциональнее и&nbsp;комфортнее, появилось много интересных
              и&nbsp;уникальных планировок. В&nbsp;большинстве квартир готовая
              отделка: качественный ламинат, обои под покраску, натяжной потолок
              и&nbsp;санузел в&nbsp;керамограните.
            </>
          ),
          url: 'https://www.pik.ru/plus?utm_source=rbc&utm_medium=display&utm_content=plus',
          buttonName: 'Узнать больше',
        },
        {
          title: 'Панорамные окна, балконы и террасы',
          image: thematicImages25['3'],
          text: (
            <>
              Во&nbsp;многих квартирах будут большие окна в&nbsp;пол, это делает
              ее&nbsp;светлой и&nbsp;просторной, или с&nbsp;угловыми панорамными
              окнами, что визуально расширяют комнату. Есть галерейные балконы
              на&nbsp;всю квартиру, открытые, французские и&nbsp;угловые балконы
              на&nbsp;две стороны. На&nbsp;верхних этажах&nbsp;&mdash; квартиры
              с&nbsp;террасами.
            </>
          ),
          url: 'https://www.pik.ru/plus?utm_source=rbc&utm_medium=display&utm_content=plus',
          buttonName: 'Узнать больше',
        },
        {
          title: 'Дизайнерские лобби',
          image: thematicImages25['4'],
          text: (
            <>
              В&nbsp;проектах просторные лобби по&nbsp;индивидуальному
              дизайн-проекту с&nbsp;качественными и&nbsp;долговечными
              материалами. В&nbsp;них панорамное остекление, высокие потолки.
              В&nbsp;лобби светло и&nbsp;уютно, входы расположены на&nbsp;уровне
              земли, здесь предусмотрены места для хранения колясок
              и&nbsp;велосипедов.
            </>
          ),
          url: 'https://www.pik.ru/projects?blocks=1196,1124,1541&zoom=9&longitude=37.52531399999995&latitude=55.7405507426746&geoBox=55.262730777604375,56.21256678935352-36.55851712499995,38.49211087499995&utm_source=rbc&utm_medium=display&utm_content=plus',
          buttonName: 'Смотреть проекты ПИК+',
        },
        {
          title: 'Не только в Москве',
          image: thematicImages25['5'],
          text: (
            <>
              Линейка ПИК+ развивается и&nbsp;в&nbsp;других городах. Например,
              сейчас в&nbsp;Санкт-Петербурге есть проекты
              &laquo;Лермонтовский&nbsp;54&raquo;
              и&nbsp;&laquo;Шкиперский&nbsp;19&raquo;, которые находятся
              в&nbsp;одних из&nbsp;лучших местах города.
            </>
          ),
          url: 'https://www.pik.ru/spb/projects?blocks=1690,1677&zoom=10&longitude=30.33910749999994&latitude=59.92990313119557&geoBox=59.71796769338927,60.14048864872432-29.85570906249994,30.82250593749994&utm_source=rbc&utm_medium=display&utm_content=plus',
          buttonName: 'ПИК+ в Санкт-Петербурге',
        },
      ],
      darkTheme: true,
      noFeedback: true,
      noAnonce: true,
      disable: true,
    },
    {
      id: '26',
      category: 'location',
      anonce: {
        title: 'Проекты ПИК в Подмосковье',
        lead: 'Квартиры в тихих уютных городах',
        anchorName: 'Проекты ПИК в Подмосковье',
        imagePath: selectionImages['26'],
      },
      about: {
        title: 'Кварталы ПИК в Московской области',
        text: 'Подмосковье — это удобные для жизни маленькие города с современными домами',
        imagePath: selectionImages['26'],
      },
      profit: {
        title: 'Почему это выгодно',
        text: 'Поселиться в Подмосковье — отличный вариант для семей и тех, кто устал от суеты мегаполиса. Здесь тишина и уют маленьких городов сочетаются с близостью к столице, а кварталы ПИК предлагают качественные дома и продуманную инфраструктуру',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Проекты ПИК в Подмосковье',
      },
    },
    {
      id: '27',
      category: 'popular',
      anonce: {
        title: 'Проекты ПИК от известных архбюро',
        lead: 'Индивидуальные дизайны фасадов',
        anchorName: 'Проекты ПИК от известных архбюро',
        imagePath: selectionImages['27'],
      },
      about: {
        title: 'Проекты ПИК от известных архбюро',
        text: 'Проекты с индивидуальным дизайном фасадов от известных архбюро',
        imagePath: selectionImages['27'],
      },
      profit: {
        title: 'Почему это интересно',
        text: 'Современные дома с собственным архитектурным характером сегодня редкость, особенно — жилые. Тем ценнее, когда для проектов приглашаются именитые студии вроде de Architekten Cie, KATARSIS, RHIZOME, Kamen Architects, Gillespies.',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Проекты ПИК от известных архбюро',
      },
    },
    {
      id: '28',
      about: {
        title: 'Преимущества проектов ПИК для детей',
        text: 'Для детей важно создать комфорт и безопасность дома, во дворе и по дороге в школу',
        imagePath: selectionImages['28'],
      },
      profit: {
        title: (
          <>
            Почему это <br />
            важно
          </>
        ),
        text: 'Дети проводят много времени вне квартиры, поэтому в современных кварталах жилая среда — от дворов и подъездов до дороги к школе — проектируется и создаётся с большим вниманием на безопасность и комфорт детей.',
        color: '#e4f0d5',
      },
      thematicContent: [
        {
          title: 'Удобные подъезды и общественные пространства',
          image: thematicImages28['1'],
          text: (
            <>
              Современные стандарты ПИК для мест общего пользования – это:
              <br />
              &#8226; Вход в&nbsp;подъезд без ступенек
              <br />
              &#8226; Домофон и&nbsp;кнопки лифта на&nbsp;комфортном для ребёнка
              уровне
              <br />
              &#8226; Face&nbsp;ID, чтобы попасть в&nbsp;дом без ключей
              <br />
              &#8226; Антивандальные безопасные материалы
              <br />
              &#8226; Понятная навигация
              <br />
              &#8226; Камеры в&nbsp;подъезде и&nbsp;лифте
              <br />
              &#8226; Светлые просторные лобби
            </>
          ),
          // url: 'https://www.pik.ru/standards?utm_source=rbc&utm_medium=display&utm_content=standards',
          // buttonName: 'Все Стандарты ПИК',
        },
        {
          title: 'Комфортный и безопасный двор',
          image: thematicImages28['2'],
          text: (
            <>
              Дворы в&nbsp;проектах ПИК под видеонаблюдением, внутрь могут
              попасть только жители дома и&nbsp;их&nbsp;гости. На&nbsp;детских
              площадках широко используются натуральные материалы: дерево,
              песок, щепа. Игровое оборудование абстрактных форм, чтобы дети
              сами придумывали сценарии игр и&nbsp;развивали фантазию.
            </>
          ),
          // url: 'https://www.pik.ru/standards?utm_source=rbc&utm_medium=display&utm_content=standards',
          // buttonName: 'Все Стандарты ПИК',
        },
        {
          title: 'Дорога до школы',
          image: thematicImages28['3'],
          text: (
            <>
              Во&nbsp;всех районах ПИК&nbsp;&mdash; полный приоритет пешеходов.
              Поэтому дорога из&nbsp;дома до&nbsp;школы и&nbsp;обратно всегда
              безопасная и&nbsp;приятная: внутри квартала даже ребёнок легко
              сориентируется и&nbsp;составит оптимальный маршрут по&nbsp;широким
              тротуарам, а&nbsp;ограничение скорости арендованных
              электросамокатов минимизирует риски.
            </>
          ),
          url: 'https://www.pik.ru/standards?utm_source=rbc&utm_medium=display&utm_content=standards',
          buttonName: 'Все Стандарты ПИК',
        },
      ],
      disable: true,
    },
    {
      id: '29',
      about: {
        title: 'Проекты с заселением в 2023 году',
        text: 'Где найти квартиру, в которую можно заехать до Нового года: собираем варианты',
        imagePath: selectionImages['29'],
      },
      profit: {
        title: (
          <>
            Почему это <br />
            важно
          </>
        ),
        text: 'Жилье в новостройке необязательно ждать годами. Среди свежих ЖК есть привлекательные проекты для тех, кто хочет получить ключи сразу. Нашли интересные варианты, куда можно заселиться в 2023 году и встретить Новый год в собственной квартире',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Заехать в 2023 году',
      },
      disable: true,
      noMetro: true,
    },
    {
      id: '30',
      about: {
        title: 'Квартиры для инвестиций',
        text: 'Какой объект выбрать, чтобы приумножить вложения в долгосрочной перспективе',
        imagePath: selectionImages['30'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Недвижимость заслуженно считают надежным инструментом для инвестиций. Особенно выгодны квартиры в новостройках: они традиционно дорожают по мере готовности дома. У ПИК большой выбор квартир на раннем этапе строительства',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Квартиры для инвестиций',
      },
      noMetro: true,
      disable: true,
    },
    {
      id: '31',
      category: 'location',
      anonce: {
        title: 'Квартиры на востоке Москвы',
        lead: 'В какой объект вложиться',
        anchorName: 'Квартиры на востоке Москвы',
        imagePath: selectionImages['31'],
      },
      about: {
        title: 'Новостройки на востоке Москвы',
        text: 'Выбираем квартиру в одном из самых перспективных округов столицы — юго-восточном',
        imagePath: selectionImages['31'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Парки, старинные усадьбы и места для отдыха всей семьей — этим известен ЮВАО. До недавнего времени здесь почти не было нового жилья, но сейчас на месте старых индустриальных территорий возводят новые ЖК. Их окружают зеленые зоны.',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Квартиры на востоке Москвы',
      },
    },
    {
      id: '32',
      about: {
        title: 'Проекты рядом с метро и МЦК',
        text: 'Ищем жилье с идеальной транспортной доступностью — с метро, автобусами и МЦК',
        imagePath: selectionImages['32'],
      },
      profit: {
        title: (
          <>
            Почему это
            <br />
            важно
          </>
        ),
        text: 'Поселиться в таком месте, откуда легко добраться в любую точку города — понятная цель, которой руководствуются многие при выборе квартиры. Нашли новые ЖК, которые построены поблизости от остановок автобусов, станций метро и МЦК.',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Квартиры у метро и МЦК',
      },
      disable: true,
    },
    {
      id: '33',
      about: {
        title: 'Проекты, которые построят в 2024 году',
        text: 'Ищем жилье в новостройках, которые будут готовы в 2024 году',
        imagePath: selectionImages['33'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'В 2024 году — в новую квартиру. Если руководствоваться этой максимой, то надо выбирать квартиру, которая будет готова очень скоро. Нашли интересные проекты на финальной стадии возведения. Некоторые из них уже введены в эксплуатацию',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Что построят в 2024 году',
      },
      disable: true,
    },
    {
      id: '34',
      about: {
        title: 'Проекты, где есть все для спорта',
        text: 'Новостройки рядом со стадионами и спорткомплексами — чтобы поддерживать форму',
        imagePath: selectionImages['34'],
      },
      profit: {
        title: (
          <>
            Почему это
            <br />
            интересно
          </>
        ),
        text: 'Заниматься спортом круглый год — непростая задача в холодном климате. Чтобы всегда оставаться в форме, нужно, чтобы тренажерные залы и спортплощадки были рядом с домом. Собрали проекты, в которых спорт сможет стать естественной частью жизни.',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Жить в спортивном режиме',
      },
      disable: true,
    },
    {
      id: '35',
      about: {
        title: 'Квартиры, где много света',
        text: 'С окнами в пол и угловым остеклением',
        imagePath: selectionImages['35'],
      },
      profit: {
        title: (
          <>
            Почему это
            <br />
            важно
          </>
        ),
        text: 'Окна в пол — мечта для многих, кто вырос в средней полосе России. Когда рано смеркается, хочется насладиться каждым лучиком солнца и впустить в дом как можно больше света. В этом помогут квартиры с панорамным остеклением во всю стену.',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Квартиры, где много света',
      },
      disable: true,
    },
    {
      id: '36',
      about: {
        title: 'Въехать в квартиру мечты досрочно',
        text: 'Составили подборку новостроек, которые будут готовы раньше обещанного срока',
        imagePath: selectionImages['36'],
      },
      profit: {
        title: (
          <>
            Почему это
            <br />
            интересно
          </>
        ),
        text: 'Поскорее вселиться в новый дом — мечта каждого, кто купил квартиру в новостройке. На практике сроки часто сдвигают на «потом». Но в ПИК сумели оптимизировать процессы на площадке и сократить срок строительства некоторых проектов.',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Новоселье раньше срока',
      },
      disable: true,
    },
    {
      id: '37',
      about: {
        title: 'Дома с новогодним настроением',
        text: 'Кварталы, где управляющие компании устраивают праздники, а во дворе стоит елка',
        imagePath: selectionImages['37'],
      },
      profit: {
        title: (
          <>
            Почему это
            <br />
            интересно
          </>
        ),
        text: ' В новом доме всегда хочется праздника — особенно, если переезжать под Новый год. В этих районах управляющие компании устраивают для жителей яркие торжества к памятным датам, а в конце декабря во дворе наряжают елку.',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Дома с новогодним настроением',
      },
      disable: true,
    },
    {
      id: '38',
      about: {
        title: 'Чем интересны умные планировки',
        text: 'Эти пространства можно адаптировать под свои пожелания — чтобы жизнь стала удобнее',
        imagePath: selectionImages['38'],
      },
      profit: {
        title: (
          <>
            Почему это <br />
            важно
          </>
        ),
        text: 'Максимум пользы независимо от площади — таков главный запрос при выборе удобной квартиры. Специально для этого компания ПИК разработала умные планировки квартир. В них учли образ жизни и потребности современных жителей мегаполиса.',
        color: '#e4f0d5',
      },
      thematicContent: [
        {
          title: 'Мастер-спальня',
          image: thematicImages38['1'],
          text: (
            <>
              Мастер-спальни&nbsp;&mdash; это комнаты с&nbsp;индивидуальным
              входом в&nbsp;собственную ванную. На&nbsp;редкость удобная
              планировка для всех, кому важно личное пространство. Здесь легко
              жить по&nbsp;собственному графику, не&nbsp;мешая никому
              в&nbsp;квартире&nbsp;&mdash; например, если нужно рано встать,
              можно принять душ и&nbsp;одеться без лишнего шума.
            </>
          ),
          // url: '#!',
          // buttonName: 'Проекты с умными планировками',
        },
        {
          title: 'Сквозной санузел',
          image: thematicImages38['2'],
          text: (
            <>
              Удобно, когда в&nbsp;ванную можно попасть с&nbsp;двух разных
              сторон&nbsp;&mdash; к&nbsp;примеру, из&nbsp;жилой комнаты
              и&nbsp;из&nbsp;прихожей. Такая ванная оптимизирует движение
              по&nbsp;квартире и&nbsp;повышает приватность, позволяя всегда
              чувствовать себя комфортно.
            </>
          ),
          // url: '#!',
          // buttonName: 'Проекты с умными планировками',
        },
        {
          title: 'Кухня-гостиная',
          image: thematicImages38['3'],
          text: (
            <>
              Просторное и&nbsp;светлое пространство для приготовления еды,
              семейного отдыха и&nbsp;встреч с&nbsp;друзьями: гостиная,
              совмещенная с&nbsp;кухней. Здесь комфортно работать, делать уроки,
              принимать гостей, устраивать вечеринки и&nbsp;проводить время всей
              семьей&nbsp;&mdash; как за&nbsp;обедом, так
              и&nbsp;за&nbsp;просмотром кино по&nbsp;вечерам.
            </>
          ),
          // url: '#!',
          // buttonName: 'Проекты с умными планировками',
        },
        {
          title: 'Кухня-ниша',
          image: thematicImages38['4'],
          text: (
            <>
              Компактная, но&nbsp;полноценная кухня, в&nbsp;которой рабочая зона
              расположена в&nbsp;удобной нише. Здесь помещается все необходимое:
              ящики с&nbsp;посудой, плита, посудомоечная машина, чайник, тостер
              и&nbsp;кофе-машина. А&nbsp;компактная площадь позволяет
              не&nbsp;транжирить место, освобождая в&nbsp;квартире место для
              жизни.
            </>
          ),
          // url: '#!',
          // buttonName: 'Проекты с умными планировками',
        },
        {
          title: 'Гардеробная',
          image: thematicImages38['5'],
          text: (
            <>
              Продуманное многофункциональное пространство для хранения одежды,
              спальных принадлежностей или других вещей. Это место можно
              обустроить по&nbsp;собственному желанию: здесь можно оборудовать
              гардероб, уютный кабинет и&nbsp;даже мини-спортзал.
            </>
          ),
          // url: '#!',
          // buttonName: 'Проекты с умными планировками',
        },
        {
          title: 'Постирочная',
          image: thematicImages38['6'],
          text: (
            <>
              Специальное пространство, где можно разместить стиральную машину
              вместе с&nbsp;сушилкой и&nbsp;средствами для стирки. Здесь&nbsp;же
              реально поставить гладильную доску или перепридумать все
              пространство, обустроив собственную студию звукозаписи или
              поставив велотренажер.
            </>
          ),
          url: 'https://www.pik.ru/search?projects=1&blocks=1580&utm_source=rbc&utm_medium=display&utm_content=smart_plans',
          buttonName: 'Квартиры с умными планировками',
        },
      ],
      disable: true,
    },
    {
      id: '39',
      about: {
        title: 'Для любителей зимних видов спорта',
        text: 'Выбираем новостройки рядом с ледовыми аренами. Чтобы поддерживать форму было легко',
        imagePath: selectionImages['39'],
      },
      profit: {
        title: (
          <>
            Почему это
            <br />
            интересно
          </>
        ),
        text: 'Оставаться в тонусе и находить развлечения для детей в холодный сезон помогают зимние виды спорта. Собрали в одном месте проекты, расположенные поблизости от катков, ледовых и хоккейных комплексов — чтобы чаще вставать на лед рядом с домом',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Спорт рядом с домом',
      },
      disable: true,
    },
    {
      id: '40',
      about: {
        title: 'За МКАДом, но с московской пропиской',
        text: 'Совместить плюсы регистрации в столице с экологичной жизнью в окружении природы',
        imagePath: selectionImages['40'],
      },
      profit: {
        title: (
          <>
            Почему это
            <br />
            важно
          </>
        ),
        text: 'Регистрация в Москве открывает много возможностей, от которых не хочется отказываться. Но есть минусы: шум, грязный воздух, толпы людей. Находим компромисс и выбираем квартиру за МКАДом, где чисто, зелено и можно получить столичную прописку',
        color: '#E3D3F7',
      },
      tables: {
        title: 'За МКАДом, но в Москве',
      },
      disable: true,
    },
    {
      id: '41',
      about: {
        title: 'Новостройки, где все нужное — у дома',
        text: 'Изучаем кварталы, где есть все для комфортной жизни: от школ до салонов красоты',
        imagePath: selectionImages['41'],
      },
      profit: {
        title: (
          <>
            Почему это
            <br />
            интересно
          </>
        ),
        text: 'Получить все необходимые для комфортной жизни услуги поблизости от дома — редкая привилегия. Собрали проекты с развитой социальной инфраструктурой, сервисами и обилием транспортных путей на случай, когда из дома все же нужно уехать',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Все нужное — у дома',
      },
      disable: true,
    },
    {
      id: '42',
      about: {
        title: 'Новостройки для ценителей прогулок',
        text: 'Кварталы со скверами и пешеходными бульварами — чтобы наслаждаться свежим воздухом',
        imagePath: selectionImages['42'],
      },
      profit: {
        title: (
          <>
            Почему это
            <br />
            важно
          </>
        ),
        text: 'Для поддержания здоровья полезно гулять по скверам и пешеходным аллеям, не отвлекаясь на шум и рабочие дела',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Дома для любителей гулять',
      },
      disable: true,
    },
    {
      id: '43',
      about: {
        title: 'Новостройки с шоурумами',
        text: 'Лично проверить будущий ремонт и планировки можно в шоуруме',
        imagePath: selectionImages['43'],
      },
      profit: {
        title: (
          <>
            Почему это
            <br />
            интересно
          </>
        ),
        text: 'Заранее осмотреть каждую деталь в новой квартире мечтает каждый. Узнать, какими будут обои, ламинат и плитка, можно в шоурумах — где воссозданы реальные планировки и отделка квартир',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Оценить будущую квартиру',
      },
      disable: true,
    },
    {
      id: '44',
      category: 'infrastructure',
      anonce: {
        title: 'Жить рядом с аквапарком',
        lead: 'Чтобы отдыхать чаще',
        anchorName: 'Жить рядом с аквапарком',
        imagePath: selectionImages['44'],
      },
      about: {
        title: 'Жить рядом с бассейном или аквапарком',
        text: 'Жилые кварталы, где можно заниматься плаванием или греться в сауне',
        imagePath: selectionImages['44'],
      },
      profit: {
        title: (
          <>
            Почему это
            <br />
            интересно
          </>
        ),
        text: 'Регулярно плавать или часто кататься с водных горок вместе с детьми можно, поселившись в жилом квартале неподалеку от бассейна либо аквапарка. А еще здесь можно ходить в сауну рядом с домом',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Жить рядом с аквапарком',
      },
    },
    {
      id: '45',
      about: {
        title: 'Самые популярные подборки квартир',
        text: 'Топ-7 подборок особенных квартир',
        imagePath: selectionImagesTop['40'],
      },
      profit: {
        title: (
          <>
            Почему это
            <br />
            важно
          </>
        ),
        text: 'Найти идеальную квартиру могут помочь подборки, объединяющие квартиры в новостройках по определенному принципу. За год эти 7 подборок оказались самыми популярными у читателей РБК',
        color: '#e4f0d5',
      },
      thematicContent: [
        {
          title: (
            <>
              Большие квартиры 90м
              <sup>
                <small>2</small>
              </sup>
              +
            </>
          ),
          image: selectionImagesTop['2'],
          text: (
            <>
              Студии есть у&nbsp;любого застройщика, а&nbsp;вот большие
              и&nbsp;хорошо спланированные квартиры&nbsp;&mdash; не&nbsp;такое
              частое предложение на&nbsp;рынке новостроек. Эта подборка особенно
              полюбилась читателям РБК: здесь представлены трех-
              и&nbsp;четырехкомнатные варианты в&nbsp;новых домах. То, что нужно
              для большой семьи
            </>
          ),
          url: '/collections/2',
          urlInner: true,
          buttonName: 'Показать всю подборку',
        },
        {
          title: 'Проекты, которые построят в 2024 году',
          image: selectionImagesTop['33'],
          text: (
            <>
              В&nbsp;2024 году&nbsp;&mdash; в&nbsp;новую квартиру. Если
              руководствоваться этой максимой, то&nbsp;надо выбирать квартиру,
              которая будет готова очень скоро. Нашли интересные проекты
              на&nbsp;финальной стадии возведения. Некоторые из&nbsp;них уже
              введены в&nbsp;эксплуатацию
            </>
          ),
          url: '/collections/33',
          urlInner: true,
          buttonName: 'Показать всю подборку',
        },
        {
          title: 'Проекты в новой Москве',
          image: selectionImagesTop['40'],
          text: (
            <>
              Регистрация в&nbsp;Москве открывает много возможностей,
              от&nbsp;которых не&nbsp;хочется отказываться. Но&nbsp;есть минусы:
              шум, грязный воздух, толпы людей. Находим компромисс
              и&nbsp;выбираем квартиру за&nbsp;МКАДом, где чисто, зелено
              и&nbsp;можно получить столичную прописку. В&nbsp;подборке
              представлены квартиры в&nbsp;Новой Москве
            </>
          ),
          url: '/collections/12',
          urlInner: true,
          buttonName: 'Показать всю подборку',
        },
        {
          title: 'Квартиры c 2 ванными комнатами',
          image: selectionImagesTop['18'],
          text: (
            <>
              Жизнь становится намного проще, когда в&nbsp;большой семье
              санузлами можно пользоваться одновременно: утром&nbsp;&mdash;
              быстрее собираться в&nbsp;школу или на&nbsp;работу,
              вечером&nbsp;&mdash; спокойно принять ванну. А&nbsp;еще это
              хороший вариант для организации гостевого туалета
            </>
          ),
          url: '/collections/18',
          urlInner: true,
          buttonName: 'Показать всю подборку',
        },
        {
          title: 'Готовые квартиры с готовой отделкой',
          image: selectionImagesTop['19'],
          text: (
            <>
              Не&nbsp;просто квартира с&nbsp;голыми стенами, а&nbsp;бережно
              подготовленное к&nbsp;жизни пространство, где все розетки
              на&nbsp;своих местах, установлены двери, а&nbsp;полы и&nbsp;стены
              готовы к&nbsp;расстановке мебели. Не&nbsp;нужно терпеть этап
              с&nbsp;ремонтом: можно сразу заехать и&nbsp;встречать гостей. Или
              в&nbsp;тот&nbsp;же день сдать квартиру в&nbsp;аренду
            </>
          ),
          url: '/collections/19',
          buttonName: 'Показать всю подборку',
        },
        {
          title: 'Доступные квартиры в пределах МКАД',
          image: selectionImagesTop['24'],
          text: (
            <>
              Есть миф, что бюджетные квартиры расположены далеко за&nbsp;МКАД.
              Эта подборка-опровержение&nbsp;&mdash; настоящий хит. Оказалось,
              что в&nbsp;столице достаточно доступных по&nbsp;цене
              квартир&nbsp;&mdash; и&nbsp;это не&nbsp;Новая Москва,
              не&nbsp;вторичное жилье и&nbsp;не&nbsp;крохотные студии. Это
              новостройки ПИК, которые отлично подходят для переезда
              в&nbsp;Москву
            </>
          ),
          url: '/collections/24',
          urlInner: true,
          buttonName: 'Показать всю подборку',
        },
        {
          title: 'Проекты рядом с метро и МЦК',
          image: selectionImagesTop['3'],
          text: (
            <>
              В&nbsp;Москве легко прожить без машины, если поселиться
              в&nbsp;пешей доступности от&nbsp;станции метро или МЦК.
              В&nbsp;подборке представлены именно такие проекты&nbsp;&mdash;
              чтобы жить, не&nbsp;задумываясь о&nbsp;времени на&nbsp;дорогу
              и&nbsp;быстро доезжать до&nbsp;любого района без пробок
              и&nbsp;ожиданий. Квартиры в&nbsp;таких местах всегда пользуются
              спросом
            </>
          ),
          url: '/collections/32',
          urlInner: true,
          buttonName: 'Показать всю подборку',
        },
      ],
      disable: true,
      // footnote:
      //   '*Расчёт возможного дохода является ориентировочным при посуточной сдаче апартаментов через Управляющую компанию «МТЛ» (УК). При расчёте возможного дохода не учтены дополнительные затраты на пакет меблировки и техники, иные дополнительные платежи и расходы, включая обязательные налоги и сборы. Возможный доход зависит от площади и состояния апартаментов, рыночной ситуации и иных факторов, действующих на день размещения информации на сайте. Указанный возможный доход в рублях рассчитан и формируется из суммы броней апартаментов за календарный месяц (которую аккумулирует УК), из которой вычитается вознаграждение УК, страховые взносы, коммунальные платежи и прочие расходы на содержание апартаментов. Любая информация, представленная на данном сайте, носит исключительно информационный характер и ни при каких условиях не является публичной офертой, определяемой положениями статьи 437 ГК РФ.',
    },
    {
      id: '46',
      about: {
        title: 'Ценителям балконов и террас ',
        text: 'Получить собственный «кусочек улицы» сможет каждый, кто купит квартиру с террасой',
        imagePath: selectionImages['46'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Балконы, лоджии и террасы добавляют квартире изюминку. Они привносят в привычный быт возможность выйти на воздух и понаблюдать за небом, двором или городом.',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Балконы, лоджии и террасы',
      },
      newTemplate: true,
      disable: true,
    },
    {
      id: '47',
      about: {
        title: 'Заехать в квартиру в начале лета',
        text: 'Здесь можно устроить новоселье в ближайшее время — дома почти готовы',
        imagePath: selectionImages['47'],
      },
      profit: {
        title: <>Почему это важно</>,
        text: 'Подобрать новостройку с возможностью быстро заселиться — особый навык. В продаже часто встречаются дома, до готовности которых остается много лет. Чтобы не затягивать переезд, можно выбрать один из вариантов с почти готовыми корпусами',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Заехать в квартиру и жить',
      },
      newTemplate: true,
      disable: true,
    },
    {
      id: '48',
      about: {
        title: 'Красиво жить в культурной столице',
        text: '4 новостройки в центре Петербурга — от Обводного канала до Васильевского острова',
        imagePath: selectionImages['48'],
      },
      profit: {
        title: (
          <>
            Почему это
            <br />
            важно
          </>
        ),
        text: 'В историческом центре Санкт-Петербурга не так часто появляются новые кварталы, поэтому каждый такой проект становится событием. Тем более когда инфраструктура комплекса продумана до мелочей еще до завершения строительства',
        color: '#E3D3F7',
      },
      thematicContent: [
        {
          title: <>Лермонтовский 54</>,
          image: thematicImages48['1'],
          text: (
            <>
              Камерный квартал в&nbsp;Адмиралтейском районе. Высокие потолки
              и&nbsp;окна в&nbsp;пол откроют впечатляющие виды на&nbsp;город.
              Выйти на&nbsp;собственную террасу или в&nbsp;патио, принять ванну
              у&nbsp;окна&nbsp;&mdash; это так по-петербургски. К&nbsp;заселению
              первой очереди внутри квартала откроется школа в&nbsp;здании,
              построенном в&nbsp;начале XIX века
            </>
          ),
          url: 'https://www.pik.ru/spb/lermontovskiy?utm_source=rbc&utm_medium=display&utm_content=lermontovsky &utm_campaign=general',
          urlInner: false,
          buttonName: 'Узнать больше',
        },
        {
          title: 'Шкиперский 19',
          image: thematicImages48['2'],
          text: (
            <>
              Жилой квартал для настоящих ценителей Васильевского
              острова&nbsp;&mdash; в&nbsp;пешей доступности от&nbsp;метро
              &laquo;Приморская&raquo; и&nbsp;рядом с&nbsp;заливом. Выбрать
              квартиру с&nbsp;окнами в&nbsp;пол или видом на&nbsp;воду.
              Историческая часть Петербурга получит продуманный проект,
              на&nbsp;территории которого уже строится садик, а&nbsp;рядом
              появится школа
            </>
          ),
          url: 'https://www.pik.ru/spb/shkiperskiy?utm_source=rbc&utm_medium=display&utm_content=shkiper_19&utm_campaign=general',
          urlInner: false,
          buttonName: 'Узнать больше',
        },
        {
          title: 'Витебский парк',
          image: thematicImages48['3'],
          text: (
            <>
              В&nbsp;масштабный проект на&nbsp;Лиговском проспекте входит семь
              жилых домов, два детских сада, школа и&nbsp;поликлиника,
              в&nbsp;каждом дворе&nbsp;&mdash; парк. Все квартиры с&nbsp;готовой
              отделкой, и&nbsp;на&nbsp;выбор будет множество планировок.
              В&nbsp;15&nbsp;минутах пешком метро &laquo;Обводный канал&raquo;,
              а&nbsp;в&nbsp;2029 году совсем рядом откроется станция
              &laquo;Боровая&raquo;
            </>
          ),
          url: 'https://www.pik.ru/spb/vitpark?utm_source=rbc&utm_medium=display&utm_content=vitebsky_park&utm_campaign=general',
          urlInner: false,
          buttonName: 'Узнать больше',
        },
        {
          title: 'Аэронавт',
          image: thematicImages48['4'],
          text: (
            <>
              Проект из&nbsp;двух корпусов вблизи от&nbsp;центра. Через него
              протянется пешеходный бульвар, а&nbsp;из&nbsp;каждой парадной
              можно будет выйти в&nbsp;тихий уютный двор-парк. Во&nbsp;всех
              квартирах&nbsp;&mdash; готовая отделка. Можно выбрать вариант
              с&nbsp;мастер-спальней, постирочной, гардеробной, лоджией, окнами
              в&nbsp;пол и&nbsp;французским балконом
            </>
          ),
          url: 'https://www.pik.ru/spb/aeronaut?utm_source=rbc&utm_medium=display&utm_content=ligovsky&utm_campaign=general',
          urlInner: false,
          buttonName: 'Узнать больше',
        },
      ],
      newTemplate: false,
      // noBanner: true,
      disable: true,
    },
    {
      id: '49',
      about: {
        title: 'Особенные квартиры в центре Петербурга',
        text: 'Комфортные планировки на Васильевском острове и на Лермонтовском проспекте',
        imagePath: selectionImages['49'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Виды на историческую часть города или Финский залив. Квартиры с террасами или патио. Планировки с вместительной гардеробной или мастер-спальней. Все эти варианты можно найти в проектах «Серии плюс» в центре Санкт-Петербурга',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Особые квартиры Петербурга',
      },
      disable: true,
    },
    {
      id: '50',
      about: {
        title: 'Новостройки с улучшенной отделкой',
        text: 'Выбираем квартиру с улучшенной отделкой: от ламината до шумоизоляции',
        imagePath: selectionImages['50'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Готовый ремонт ПИК+ позволяет не тратить силы, а сразу заехать в обустроенную квартиру. Здесь постелен износостойкий ламинат, смонтированы натяжные потолки, на стенах — обои под покраску, а входная дверь с дополнительной шумоизоляцией',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Квартиры с особой отделкой',
      },
      disable: true,
    },
    {
      id: '51',
      category: 'popular',
      anonce: {
        title: 'Сделано в России',
        lead: 'Из отечественных комплектующих',
        anchorName: 'Сделано в России',
        imagePath: selectionImages['51'],
      },
      about: {
        title: 'Отечественные стройматериалы',
        text: 'Все окна, лифты, железобетонные блоки и фасады этих домов сделаны в России',
        imagePath: selectionImages['51'],
      },
      profit: {
        title: <>Почему это важно</>,
        text: 'Полная локализация — это сложно. Не каждая новостройка может похвастать тем, что все её части — отечественного производства. Здесь собраны именно такие проекты: со строгим контролем качества материалов и устойчивостью к любым погодным условиям',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Сделано в России',
      },
      //  noMetro: true, если квартиры в городах где нет метро (это поле обычно должно быть удалено)
    },
    {
      id: '52',
      about: {
        title: 'Удобные офисы у метро «Озерная»',
        text: 'Чем интересны помещения в новом торгово-офисном комплексе Lakes в Москве',
        imagePath: selectionImages['52'],
      },
      profit: {
        title: <>Почему это важно</>,
        text: 'Офисная недвижимость сейчас на пике спроса: в столице наблюдается нехватка помещений. Деловой центр Lakes станет привлекательным вариантом и для инвесторов, и для тех, кому нужно разместить собственный бизнес в шаговой доступности от метро',
        color: '#e4f0d5',
      },
      thematicContent: [
        {
          title: <>Офисы и&nbsp;торговля в&nbsp;одном здании</>,
          image: thematicImages52['1'],
          text: (
            <>
              Lakes&nbsp;&mdash; многофункциональный комплекс площадью
              55&nbsp;тыс.&nbsp;кв.&nbsp;м. Офисы расположатся
              с&nbsp;5&nbsp;по&nbsp;17&nbsp;этаж и&nbsp;займут
              19&nbsp;тыс.&nbsp;кв.&nbsp;м, ниже разместится ретейл. Это первый
              отдельностоящий объект коммерческой недвижимости класса&nbsp;В+
              от&nbsp;ПИК. Здание соединит в&nbsp;себе торговый центр,
              гастрономическое и&nbsp;офисное пространства
            </>
          ),
        },
        {
          title: <>Варианты для бизнеса и&nbsp;инвесторов</>,
          image: thematicImages52['2'],
          text: (
            <>
              В&nbsp;проекте представлена полная линейка площадей:
              от&nbsp;53&nbsp;кв.&nbsp;м&nbsp;для инвестиций, малого
              и&nbsp;среднего бизнеса до&nbsp;видовых лотов площадью
              до&nbsp;1&nbsp;372&nbsp;кв.&nbsp;м&nbsp;на&nbsp;последних этажах.
              Офисы могут привлечь инвесторов, нацеленных на&nbsp;покупку
              и&nbsp;последующую сдачу помещения в&nbsp;аренду
            </>
          ),
        },
        {
          title: <>Действительно удобные планировки</>,
          image: thematicImages52['3'],
          text: (
            <>
              Все инженерные коммуникации бизнес-центра Lakes разместят
              в&nbsp;центральном блоке. Это позволит сделать свободную
              планировку, чтобы каждый резидент смог обустроить офис
              по&nbsp;своему вкусу. Такое инженерное решение также улучшает
              инсоляцию, впуская в&nbsp;помещения максимум солнечного света
            </>
          ),
        },
        {
          title: <>Магазины и&nbsp;кафе для сотрудников</>,
          image: thematicImages52['4'],
          text: (
            <>
              С&nbsp;1&nbsp;по&nbsp;4&nbsp;этаж разместится торговый комплекс
              площадью 24&nbsp;тыс.&nbsp;кв.&nbsp;м. Здесь появится супермаркет,
              магазины одежды, обуви, детский развлекательный центр.
              На&nbsp;3&nbsp;этаже откроется гастрономическое пространство
              с&nbsp;атмосферой ресторана. Особенностью проекта станет
              двухэтажный фитнес-клуб с&nbsp;летней террасой
            </>
          ),
        },
        {
          title: <>Важные детали</>,
          image: thematicImages52['5'],
          text: (
            <>
              Ввод в&nbsp;эксплуатацию бизнес-центра Lakes запланирован
              на&nbsp;четвертый квартал 2025&nbsp;года. Архитектурную концепцию
              разработало проектное бюро Apex. В&nbsp;многофункциональном
              торгово-офисном комплексе также предусмотрена подземная парковка
              на&nbsp;238 машино-мест
            </>
          ),
          url: 'https://lakes-office.ru?utm_source=rbc&utm_medium=display&utm_content=lakes&utm_campaign=general',
          buttonName: 'Узнать больше',
        },
      ],
      disable: true,
    },
    {
      id: '53',
      about: {
        title: 'Умные планировки',
        text: 'Выбрать квартиру для разных сценариев жизни',
        video: {
          src: '/videos/collection53/06_47s_loundry_4k_montage.mp4',
          mutedControl: true,
        },
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Умные планировки позволяют просчитать варианты использования каждого помещения на годы вперед. Например, в двухкомнатной квартире вторая комната может стать детской, рабочим кабинетом или мини-спортзалом',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Умные планировки',
      },
      disable: true,
    },
    {
      id: '54',
      category: 'location',
      anonce: {
        title: 'Переехать ближе к парку',
        lead: 'Новостройки у зеленых массивов',
        anchorName: 'Дома у парков и лесов',
        imagePath: selectionImages['54'],
      },
      about: {
        title: 'Как переехать ближе к парку',
        text: 'Находим новостройки, которые возводят в непосредственной близости от зеленых зон',
        imagePath: selectionImages['54'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Найти свежий воздух в мегаполисе — нетривиальная задача. Решить ее помогают новые дома, которые строят в шаговой доступности от парков, скверов и даже участков леса, куда можно в любой момент отправиться на прогулку',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Дома у парков и лесов',
      },
    },
    {
      id: '55',
      category: 'location',
      anonce: {
        title: 'Жить у воды',
        lead: 'Новостройки у реки или озера',
        anchorName: 'Жить у воды',
        imagePath: selectionImages['55'],
      },
      about: {
        title: 'Новостройки на берегу рек и озер',
        text: 'Ищем размеренную жизнь и отдыхаем от городской суеты в домах у воды',
        imagePath: selectionImages['55'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Поселиться у водоема — заветная мечта для множества людей. Здесь можно каждый день гулять по набережным, принимать солнечные ванны, слушать плеск волн или просто наблюдать за водной гладью из окна. В подборке собраны проекты у рек и озер',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Жить у воды',
      },
    },
    {
      id: '56',
      category: 'popular',
      anonce: {
        title: 'Самые популярные кварталы',
        lead: 'Новостройки в Московском регионе',
        anchorName: 'Самые популярные кварталы',
        imagePath: selectionImages['56'],
      },
      about: {
        title: 'Самые популярные кварталы ПИК',
        text: 'Что объединяет самые востребованные новостройки ПИК в Москве и области',
        imagePath: selectionImages['56'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Эти кварталы ПИК оказались наиболее популярными благодаря оптимальному соотношению цены и локации, а также особенному благоустройству. Покупателей привлек широкий выбор планировок и корпусов с разными видами',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Самые популярные кварталы',
      },
    },
    {
      id: '57',
      category: 'popular',
      anonce: {
        title: 'Помещения для бизнеса',
        lead: 'На первых этажах в кварталах ПИК',
        anchorName: 'Помещения для бизнеса',
        imagePath: selectionImages['57'],
      },
      about: {
        title: 'Помещения для бизнеса в кварталах ПИК',
        text: 'Интересные варианты коммерческой недвижимости на первых этажах жилых домов',
        video: {
          src: '/videos/collection57/2023-08-21_KH_v2.mp4',
          mutedControl: true,
          topMutedButton: true,
        },
      },
      profit: {
        title: <>Почему это важно</>,
        text: 'Коммерческие помещения в жилых районах — привлекательный вариант для инвестиций. Покупка такого объекта позволит сдавать его в аренду и генерировать стабильный рентный доход. А в проектах ПИК можно найти лоты по выгодной цене',
        color: '#e4f0d5',
      },
      thematicContent: [
        {
          title: <>Востребованность объектов</>,
          image: thematicImages57['1'],
          text: (
            <>
              Первое, на&nbsp;что стоит смотреть при выборе коммерческого
              помещения&nbsp;&mdash; потенциальный спрос на&nbsp;аренду. Спрос
              будет тем выше, чем более универсальным окажется помещение: оно
              должно подходить и&nbsp;для пекарни, и&nbsp;для зоомагазина,
              и&nbsp;для пункта выдачи заказов, и&nbsp;для салона красоты
              одновременно
            </>
          ),
        },
        {
          title: <>Особенности помещений</>,
          image: thematicImages57['2'],
          text: (
            <>
              В&nbsp;условиях быстро меняющихся трендов ключевым аспектом
              становятся базовые характеристики помещения: высокие потолки,
              витринное остекление и&nbsp;свободные планировки, которые подходят
              любому типу бизнеса. Желательно также отсутствие ступенек для
              входа. Ровно такие помещения можно найти в&nbsp;проектах ПИК
            </>
          ),
        },
        {
          title: <>Удобные планировки</>,
          image: thematicImages57['3'],
          text: (
            <>
              Еще один фактор&nbsp;&mdash; конфигурация лота. В&nbsp;новых
              кварталах ПИК специально подумал об&nbsp;удобстве арендаторов
              коммерческих площадей: здесь минимум несущих стен и&nbsp;пилонов,
              чтобы любой тип бизнеса мог комфортно разместиться внутри
            </>
          ),
        },
        {
          title: <>Плотность застройки</>,
          image: thematicImages57['4'],
          text: (
            <>
              Получить высокий рентный доход можно там, где стрит-ретейл
              по-настоящему востребован&nbsp;&mdash; то&nbsp;есть
              в&nbsp;заселенных кварталах с&nbsp;плотной застройкой. Именно
              такую среду формирует ПИК: высокая этажность домов обеспечит
              бизнес активным пешеходным трафиком
            </>
          ),
        },
        {
          title: <>Прогнозируемая цена</>,
          image: thematicImages57['5'],
          text: (
            <>
              Наконец, большую роль играет предсказуемость цены&nbsp;&mdash;
              и&nbsp;здесь ПИК предлагает максимально прозрачные условия. Чем
              ближе дата сдачи дома, тем дороже становятся коммерческие площади:
              среднем стоимость увеличивается на&nbsp;8&ndash;10% в&nbsp;год.
              А&nbsp;при покупке на&nbsp;ранней стадии можно получить наиболее
              низкий ценник
            </>
          ),
          url: 'https://www.pik.ru/business/search?projects=1&blocks=1167,156,1688,55,1424,1372&areaFrom=40&areaTo=95&&utm_source=rbc',
          buttonName: 'Узнать больше',
        },
      ],
    },
    {
      id: '58',
      anonce: {
        title: 'Виртуальный шоурум',
        lead: '«Примерить» квартиру в VR-шлеме',
        anchorName: 'Виртуальный шоурум',
        video: {
          src: '/videos/collection58/RBC_PIK_Master_NEW2.mp4',
          mutedControl: true,
          topMutedButton: true,
        },
      },
      about: {
        title: 'Что посмотреть в виртуальном шоуруме',
        text: 'Здесь можно «примерить» квартиру: оценить ее удобство, функциональность и отделку',
        video: {
          src: '/videos/collection58/RBC_PIK_Master_NEW2.mp4',
          mutedControl: true,
          topMutedButton: true,
        },
      },
      profit: {
        title: <>Почему это важно</>,
        text: 'В проекте «Западный порт» в 5 минутах от метро «Фили» открылся виртуальный шоурум. Здесь можно надеть VR-шлем и почувствовать себя внутри квартиры ПИК. Представлены более 1000 планировок, доступных в разных городах России',
        color: '#E3D3F7',
      },
      thematicContent: [
        {
          title: <>Погулять по&nbsp;будущей квартире</>,
          image: thematicImages58['1'],
          text: (
            <>
              Изучить планировку на&nbsp;схеме&nbsp;&mdash; это одно.
              &laquo;Прогуляться&raquo; по&nbsp;самой квартире,
              отремонтированной и&nbsp;обставленной,&nbsp;&mdash; совсем другое.
              Современные VR-технологии позволяют оказаться в&nbsp;еще
              не&nbsp;построенном доме и&nbsp;пройтись по&nbsp;комнатам будущего
              жилья, чтобы заранее оценить, насколько подходит конкретная
              планировка
            </>
          ),
        },
        {
          title: <>Прикинуть ремонт и&nbsp;меблировку</>,
          image: thematicImages58['2'],
          text: (
            <>
              Благодаря виртуальному шоуруму не&nbsp;нужно тратить время
              и&nbsp;деньги на&nbsp;собственный дизайн-проект: увидеть квартиру
              c&nbsp;отделкой можно своими глазами и&nbsp;совершенно бесплатно.
              Возможно, идеи из&nbsp;виртуальной реальности станут источником
              вдохновения при оформлении собственного жилья
            </>
          ),
        },
        {
          title: <>Выбрать из&nbsp;1000 вариантов</>,
          image: thematicImages58['3'],
          text: (
            <>
              Сейчас в&nbsp;виртуальном шоуруме доступна 1000 планировок
              квартир. В&nbsp;будущем здесь появятся интерактивные 3D-модели
              всех квартир ПИК со&nbsp;всей страны. Шоурум открыт
              по&nbsp;предварительной записи на&nbsp;сайте ПИК каждый день
              с&nbsp;9&nbsp;до&nbsp;21&nbsp;часа без выходных в&nbsp;квартале
              &laquo;Западный порт&raquo; у&nbsp;метро &laquo;Фили&raquo;
            </>
          ),
          url: 'https://www.pik.ru/search?projects=1&blocks=1220,1421,1555,1272,320,1124,1200,1688,1692,1372,519&areaFrom=40&utm_source=rbc&utm_medium=display&utm_content=allflats',
          buttonName: 'Выбрать и записаться',
        },
      ],
      disable: true,
    },
    {
      id: '59',
      category: 'popular',
      anonce: {
        title: 'Квартиры с гардеробными',
        lead: 'Для ежедневного удобства',
        anchorName: 'Квартиры с гардеробом',
        imagePath: selectionImages['59'],
      },
      about: {
        title: 'Квартиры с гардеробными и постирочными',
        text: 'Изучаем планировки, где есть отдельные помещения для хранения и стирки вещей',
        imagePath: selectionImages['59'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Гардеробные — удобный элемент планировки, сделанный для комфорта: здесь легко хранить вещи разных размеров и зонировать пространство. А в постирочной можно установить стиральную и сушильную машины, держать гладильную доску и отпариватель',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Квартиры с гардеробом',
      },
      linkLastCard:
        'https://www.pik.ru/projects?blocks=156,518,1580,161,1411,320,1372,378,1709&status=free&utm_source=rbc&utm_medium=display&utm_content=allflats',
    },
    {
      id: '60',
      category: 'infrastructure',
      anonce: {
        title: 'Инфраструктура для спорта',
        lead: 'Кварталы со скейт-парками',
        anchorName: 'Спорт у дома',
        imagePath: selectionImages['60'],
      },
      about: {
        title: 'Кварталы со спортивной составляющей',
        text: 'Изучаем новостройки со скейт-парками, велодорожками и трассами для вейкборда',
        imagePath: selectionImages['60'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Для приверженцев здорового образа жизни важно заниматься спортом рядом с домом — желательно у себя в квартале. Специально для таких людей ПИК собрал несколько проектов с развитой спортивной инфраструктурой: от скейт-парков до вейкборд-трасс',
        color: '#E3D3F7',
      },
      tables: {
        title: 'Инфраструктура для спорта',
      },
      linkLastCard:
        'https://www.pik.ru/projects?blocks=55,118,1200,1401,411,1411,464,161,320,294,164,137,130,147&status=free&utm_source=rbc&utm_medium=display&utm_content=allflats',
    },
    {
      id: '61',
      category: 'popular',
      anonce: {
        title: 'Квартиры с открытыми балконами',
        lead: 'В новых кварталах ПИК',
        anchorName: 'Открытые балконы',
        imagePath: selectionImages['61'],
      },
      about: {
        title: 'Квартиры с балконами',
        text: 'Здесь удобно пить кофе с видом на город или заниматься йогой на свежем воздухе',
        imagePath: selectionImages['61'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Открытый балкон — это возможность в любой момент оказаться на свежем воздухе. Здесь можно встречать рассветы и наслаждаться атмосферой города, не покидая дом. А по вечерам устраивать семейные ужины под открытым небом',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Открытые балконы',
      },
      linkLastCard:
        'https://www.pik.ru/search?projects=1&blocks=1709,1108,1556,1519,1580,118,1200,1129&status=free&utm_source=rbc&utm_medium=display&utm_content=allflats',
    },
    {
      id: '62',
      category: 'popular',
      anonce: {
        title: 'Чем интересна «Серия плюс»',
        lead: 'Какие дома вошли в новую линейку',
        anchorName: 'Что такое «Серия плюс»',
        imagePath: selectionImages['62'],
      },
      about: {
        title: 'Что такое «Серия плюс»',
        text: 'Чем интересна особая линейка компании ПИК с новым уровнем комфорта',
        imagePath: selectionImages['62'],
      },
      profit: {
        title: <>Почему это важно</>,
        text: 'Компания ПИК запустила новую линейку новостроек повышенного комфорта. Она получила название «Серия плюс». Здесь собраны особые дома с индивидуальным подходом к проектированию. Разбираемся, что отличает квартиры «Серии плюс»',
        color: '#E3D3F7',
      },
      thematicContent: [
        {
          title: <>Продуманная архитектура</>,
          image: thematicImages62['20'],
          text: (
            <>
              В&nbsp;&laquo;Серии плюс&raquo; фасады стали выразительнее,
              появились новые элементы: эркеры, террасы, пешеходные галереи
              и&nbsp;угловые балконы. Первые этажи создают в&nbsp;кварталах
              уютную городскую среду: здесь можно прогуляться или пойти
              за&nbsp;покупками рядом с&nbsp;домом
            </>
          ),
        },

        {
          title: <>Разнообразное остекление</>,
          image: thematicImages62['19'],
          text: (
            <>
              Отличительная особенность &laquo;Серии плюс&raquo;&nbsp;&mdash;
              большие окна и&nbsp;обилие вариантов остекления. Здесь можно найти
              квартиры с&nbsp;окнами в&nbsp;пол, угловыми или панорамными окнами
              почти во&nbsp;всю стену&nbsp;&mdash; чтобы пробовать смелые
              дизайнерские идеи, а&nbsp;в&nbsp;каждой комнате было стильно,
              светло и&nbsp;уютно
            </>
          ),
        },

        {
          title: <>Особенные балконы</>,
          image: thematicImages62['18'],
          text: (
            <>
              Широкие галерейные балконы на&nbsp;всю квартиру, угловые балконы,
              выходящие на&nbsp;две стороны дома одновременно, или лаконичные
              французские балконы, соединяющие эстетические запросы
              на&nbsp;дизайнерский облик дома
              с&nbsp;функциональностью&nbsp;&mdash; в&nbsp;линейке &laquo;Серия
              плюс&raquo; можно выбрать любой из&nbsp;этих вариантов
            </>
          ),
        },

        {
          title: <>Террасы</>,
          image: thematicImages62['17'],
          text: (
            <>
              Предложение для особых ценителей&nbsp;&mdash; открытые террасы,
              где можно ощутить ритм города, поработать на&nbsp;свежем воздухе
              или насладиться летним вечером в&nbsp;кругу друзей и&nbsp;близких.
              А&nbsp;надежная гидроизоляция и&nbsp;качественная плитка сделают
              пребывание на&nbsp;террасе удобным в&nbsp;любое время года
            </>
          ),
        },

        {
          title: <>Умные планировки</>,
          image: thematicImages62['15'],
          text: (
            <>
              В&nbsp;&laquo;Серии плюс&raquo; представлены дома
              с&nbsp;интересной архитектурой, функциональными планировками
              и&nbsp;разнообразным остеклением. Для строительства используются
              продвинутые архитектурные решения. Разбираемся, чем интересны эти
              проекты
            </>
          ),
        },

        {
          title: <>Функциональное отопление</>,
          image: thematicImages62['14'],
          text: (
            <>
              В&nbsp;проектах &laquo;Серии плюс&raquo; мы&nbsp;делаем
              горизонтальную разводку отопления&nbsp;&mdash; трубы будут
              проходить в&nbsp;стяжке пола, а&nbsp;не&nbsp;вдоль стен. Система
              отопления в&nbsp;проектах будет коллекторной&nbsp;&mdash;
              с&nbsp;ней температуру можно регулировать и&nbsp;подстраивать под
              себя, не&nbsp;мешая соседям. Например, для ремонта можно отключить
              только один конвектор, не&nbsp;перекрывая отопление в&nbsp;других
              комнатах и&nbsp;тем более в&nbsp;квартирах
            </>
          ),
        },

        {
          title: <>Теплые полы</>,
          image: thematicImages62['13'],
          text: (
            <>
              Теплый пол&nbsp;&mdash; это дополнительный уровень комфорта
              в&nbsp;квартире. С&nbsp;таким оснащением не&nbsp;получится
              наступить на&nbsp;холодный кафель, выходя из&nbsp;горячей ванны.
              Нужную температуру пола легко настроить при помощи
              терморегулятора: широкий диапазон регулировки гибко подстроится
              под любые предпочтения
            </>
          ),
        },

        {
          title: <>Бесшумные лифты</>,
          image: thematicImages62['16'],
          text: (
            <>
              Чтобы добиться плавности хода и&nbsp;тишины в&nbsp;лифте,
              в&nbsp;механизме используют не&nbsp;обычные компенсирующие цепи,
              а&nbsp;обрезиненные. Стены и&nbsp;крыши кабин дополнительно
              обшивают звукоизолирующим материалом. Кабины просторные,
              а&nbsp;их&nbsp;высота увеличена: внутри удобно перевозить
              велосипеды, коляски и&nbsp;даже мебель
            </>
          ),
        },

        {
          title: <>Три варианта отделки</>,
          image: thematicImages62['12'],
          text: (
            <>
              В&nbsp;&laquo;Серии плюс&raquo; доступна готовая
              и&nbsp;предчистовая отделка, а&nbsp;также квартиры без ремонта.
              В&nbsp;случае с&nbsp;готовой отделкой в&nbsp;комнатах уже есть
              натяжной потолок, обои под покраску и&nbsp;качественный ламинат,
              пол санузла выложен керамогранитом, а&nbsp;внутри установлена
              сантехника, включая ванну с&nbsp;экраном
            </>
          ),
        },

        // {
        //   title: <>Разнообразие остекления</>,
        //   image: thematicImages62['2'],
        //   text: (
        //     <>
        //       Еще одна отличительная особенность новой линейки&nbsp;&mdash;
        //       обилие вариантов остекления. Здесь можно найти квартиры
        //       с&nbsp;окнами в&nbsp;пол, с&nbsp;классическим остеклением
        //       и&nbsp;даже с&nbsp;угловыми панорамными окнами во&nbsp;всю
        //       стену&nbsp;&mdash; чтобы пробовать смелые дизайнерские идеи,
        //       а&nbsp;в&nbsp;каждой комнате было стильно, светло и&nbsp;уютно
        //     </>
        //   ),
        // },

        // {
        //   title: <>Летние террасы</>,
        //   image: thematicImages62['6'],
        //   text: (
        //     <>
        //       Предложение для особых ценителей&nbsp;&mdash; открытые террасы,
        //       где можно почувствовать ритм города и&nbsp;насладиться летним
        //       вечером в&nbsp;кругу друзей и&nbsp;близких. Для ограждения террас
        //       используют закаленное стекло&nbsp;&mdash; прочное
        //       и&nbsp;термостойкое. Оно сможет надежно защитить от&nbsp;ветра
        //       и&nbsp;не&nbsp;будет закрывать вид на&nbsp;город
        //     </>
        //   ),
        // },
        // {
        //   title: <>Запоминающаяся архитектура</>,
        //   image: thematicImages62['7'],
        //   text: (
        //     <>
        //       В&nbsp;&laquo;Серии плюс&raquo; фасады стали выразительнее
        //       и&nbsp;пластичнее, появились новые элементы: эркеры, террасы,
        //       галереи и&nbsp;угловые балконы. Первые этажи выделены особенно,
        //       так как их&nbsp;чаще всего видят вблизи. Здесь благодаря выбору
        //       цветов, материалов и&nbsp;фасадных решений создается уютное
        //       пространство для прогулок
        //     </>
        //   ),
        // },
        {
          title: <>Дизайнерские лобби</>,
          image: thematicImages62['11'],
          text: (
            <>
              Входные группы делают по&nbsp;специальному дизайн-проекту.
              В&nbsp;оформлении используют долговечные материалы разных текстур
              в&nbsp;натуральной цветовой гамме. Благодаря остеклению
              и&nbsp;высоким потолкам в&nbsp;лобби всегда светло и&nbsp;уютно.
              Вертикальные почтовые ящики в&nbsp;нише с&nbsp;акцентной
              подсветкой дополнят современный облик
            </>
          ),
          url: 'https://www.pik.ru/search?projects=1&estateClassTypes=plus&utm_source=rbc',
          buttonName: 'Посмотреть все квартиры «Серии плюс»',
          buttonCenter: true,
        },

        // {
        //   title: <>Подземные этажи</>,
        //   image: thematicImages62['10'],
        //   text: (
        //     <>
        //       На&nbsp;цокольных уровнях &laquo;Серии плюс&raquo; появится
        //       отдельная удобная среда. Она будет включать просторную подземную
        //       парковку с&nbsp;широкими местами и&nbsp;зарядными станциями для
        //       электрокаров, кладовые, где можно хранить вещи, и&nbsp;даже
        //       парковку для велосипедов и&nbsp;самокатов. Все это создаст особый
        //       комфорт для жителей
        //     </>
        //   ),
        //   url: 'https://www.pik.ru/search?projects=1&estateClassTypes=plus&utm_source=rbc&utm_medium=display&utm_content=allflats',
        //   buttonName: 'Все проекты «Серия плюс»',
        // },
        // {
        //   title: <></>,
        //   image: thematicImages62['2'],
        //   text: <></>,
        //   url: 'https://www.pik.ru/projects?blocks=1541,1129,1709,1196,1580,1124,1108&status=free&utm_source=rbc&utm_medium=display&utm_content=allflats ',
        //   buttonName: 'Все проекты «Серия плюс»',
        // },
      ],
    },
    {
      id: '63',
      category: 'location',
      anonce: {
        title: 'На Васильевском острове',
        lead: 'Поселиться у Финского залива',
        anchorName: '«Шкиперский 19» у залива',
        imagePath: selectionImages['63'],
      },
      about: {
        title: 'Поселиться на Васильевском острове',
        text: 'В квартале «Шкиперский 19» вблизи Финского залива и в пешей доступности от метро',
        imagePath: selectionImages['63'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: '«Шкиперский 19» — особое место для ценителей Васильевского острова. Здесь будут квартиры с высокими потолками и окнами в пол, чтобы любоваться заливом. А двор станет приватной территорией, где тихо и уютно, много зелени и нет машин',
        color: '#e4f0d5',
      },
      tables: {
        title: 'На Васильевском острове',
      },
      linkLastCard:
        'https://www.pik.ru/spb/shkiperskiy?utm_source=rbc&utm_medium=display&utm_content=allflats',
    },
    {
      id: '64',
      category: 'infrastructure',
      anonce: {
        title: 'Двор-парк: чем заняться',
        lead: 'Гамаки, луг для йоги, лавочки',
        anchorName: 'Дворы-парки для досуга',
        imagePath: selectionImages['64'],
      },
      about: {
        title: 'Чем заняться во дворе-парке',
        text: 'В своих кварталах ПИК оборудует дворы-парки, где есть множество вариантов досуга',
        imagePath: selectionImages['64'],
      },
      profit: {
        title: <>Почему это важно</>,
        text: 'Выйти из дома и сразу оказаться в зеленом окружении — мечта для жителей мегаполиса. В своих проектах компания ПИК воплощает концепцию, которая объединяет двор и парк в одном месте. Разберемся, из чего состоят такие пространства',
        color: '#E3D3F7',
      },
      thematicContent: [
        {
          title: <>Гамаки и шезлонги</>,
          slider: thematicImages64['1'],
          text: (
            <>
              Прямо во&nbsp;дворах расставлены шезлонги и&nbsp;развешаны
              гамаки&nbsp;&mdash; чтобы в&nbsp;летний полдень или вечером после
              рабочего дня растянуться на&nbsp;свежем воздухе. Здесь можно
              почитать книгу, послушать музыку в&nbsp;наушниках или даже
              поспать, наслаждаясь летом и&nbsp;близостью природы.
              А&nbsp;на&nbsp;шезлонге будет удобно загорать
            </>
          ),
          url: 'https://www.pik.ru/projects?blocks=411,481,118,1688,1692,1108,1372,464,1124,1519,156,172,65&status=free&utm_source=rbc&utm_medium=display&utm_content=allflats',
          buttonName: 'Посмотреть проекты',
        },

        {
          title: <>Луг для йоги</>,
          slider: thematicImages64['2'],
          text: (
            <>
              Во&nbsp;дворах-парках ПИК йога обещает стать исключительно
              приятной. Дело не&nbsp;только в&nbsp;близости деревьев
              и&nbsp;кустарников, которые обеспечат столь нужное для йоги
              природное окружение. Отличительная черта луга в&nbsp;проектах
              ПИК&nbsp;&mdash; определенное покрытие, на&nbsp;котором выполнение
              стоек&nbsp;&mdash; асан&nbsp;&mdash; станет особенно удобным
            </>
          ),
          url: 'https://www.pik.ru/projects?blocks=411,118,1200,1688,1108,1692,1129,1519,320,294,156,172,65&status=free&utm_source=rbc&utm_medium=display&utm_content=allflats',
          buttonName: 'Посмотреть проекты',
        },
        {
          title: <>Специально для «Серии Плюс»</>,
          slider: thematicImages64['3'],
          text: (
            <>
              Посидеть на&nbsp;лавочке, наслаждаясь природой и&nbsp;жмурясь
              на&nbsp;солнце&nbsp;&mdash; за&nbsp;этим во&nbsp;двор-парк
              в&nbsp;&laquo;Серии Плюс&raquo; можно выйти в&nbsp;любое время,
              ведь прямо в&nbsp;поверхность будут встроены USB-разъемы, чтобы
              зарядить телефон или ноутбук, не&nbsp;возвращаясь домой.
              А&nbsp;в&nbsp;столах для пикника к&nbsp;портам добавят
              бесконтактные зарядки
            </>
          ),
          url: 'https://www.pik.ru/search?projects=1&estateClassTypes=plus&utm_source=rbc&utm_medium=display&utm_content=allflats',
          buttonName: 'Посмотреть проекты',
        },
      ],
    },
    {
      id: '65',
      anonce: {
        title: 'Грамотно сдать квартиру',
        lead: 'Самостоятельно без риелтора',
        anchorName: 'Как сдать в аренду',
      },
      about: {
        title: 'Как правильно сдать квартиру в аренду',
        text: 'Чтобы зарабатывать на аренде без хлопот, важно подготовиться. Вот план из 6 шагов',
        imagePath: selectionImages['65'],
      },
      profit: {
        title: <>Почему это важно</>,
        text: 'Превратить недвижимость в источник дохода реально — и для этого не нужны посредники. Чтобы самостоятельно сдать квартиру, достаточно помнить 5 простых правил. А если не хочется тратить время, всегда можно обратиться в ПИК-Аренда',
        color: '#E3D3F7',
      },
      thematicContent: [
        {
          title: <>Составить план</>,
          image: thematicImages65['1'],
          text: (
            <>
              Кому выгоднее сдавать: семьям или одиночкам? Стоит&nbsp;ли
              рассчитывать на&nbsp;долгосрочный контракт или сдавать посуточно?
              Какой размер оплаты установить? Ответить на&nbsp;все эти вопросы
              важно в&nbsp;самом начале&nbsp;&mdash; чтобы затем
              не&nbsp;возникало сюрпризов. Тогда останется просто следовать
              плану
            </>
          ),
        },
        {
          title: <>Подготовить квартиру</>,
          image: thematicImages65['6'],
          text: (
            <>
              Чтобы привлечь надежных арендаторов, важно сделать квартиру
              удобной и&nbsp;уютной. Закупить необходимую мебель и&nbsp;технику,
              проверить, что все правильно подключено и&nbsp;работает, устранить
              любые дефекты и&nbsp;снабдить будущих жителей посудой.
              А&nbsp;еще&nbsp;&mdash; сделать уборку. Для этого можно нанять
              клининговую компанию
            </>
          ),
        },
        {
          title: <>Собрать документы</>,
          image: thematicImages65['3'],
          text: (
            <>
              Важно показать арендаторам, что все соответствует
              закону&nbsp;&mdash; поэтому на&nbsp;сделку лучше принести договор
              купли-продажи. Это докажет, что квартиру сдает собственник.
              Не&nbsp;менее важно заранее составить договор аренды,
              в&nbsp;котором прописан срок действия, размер оплаты и&nbsp;все
              прочие условия, включая форс-мажор
            </>
          ),
        },
        {
          title: <>Найти арендатора</>,
          image: thematicImages65['4'],
          text: (
            <>
              Самый интересный шаг: поиск арендатора. Здесь потребуется
              составить емкое и&nbsp;честное объявление
              с&nbsp;10-20&nbsp;фотографиями. А&nbsp;дальше&nbsp;&mdash;
              провести показы и&nbsp;выбрать того арендатора, что понравился
              больше всех. Или того, что предложит поднять ставку
              и&nbsp;заплатить больше остальных
            </>
          ),
        },
        {
          title: <>Защитить имущество</>,
          image: thematicImages65['5'],
          text: (
            <>
              Чтобы аренда не&nbsp;вышла в&nbsp;минус, нужно позаботиться
              о&nbsp;защите своей собственности. Во-первых, на&nbsp;стадии
              заключения договора составить опись всего, что находится
              в&nbsp;квартире. Во-вторых, оформить страховку или установить для
              жильцов залог. А&nbsp;в-третьих&nbsp;&mdash; регулярно проверять
              сохранность квартиры и&nbsp;имущества
            </>
          ),
          url: '',
          buttonName: '',
        },
        {
          title: <>Обратиться в&nbsp;ПИК-Аренда</>,
          image: thematicImages65['2'],
          text: (
            <>
              Если нет времени и&nbsp;желания заниматься арендой лично, можно
              поручить это ПИК-Аренда&nbsp;&mdash; сервису, который возьмет
              на&nbsp;себя заботы по&nbsp;оформлению документов и&nbsp;поиску
              жильцов. На&nbsp;всем сроке аренды он&nbsp;сможет заняться
              решением вопросов, если они возникнут, а&nbsp;также будет высылать
              собственнику регулярные отчеты
            </>
          ),
          url: 'https://pik-arenda.ru?utm_source=rbc&utm_medium=display&utm_content=allflats',
          buttonName: 'Узнать больше',
        },
      ],
      disable: true,
    },
    {
      id: '66',
      category: 'infrastructure',
      anonce: {
        title: 'Площадки для баскетбола',
        lead: 'Рядом с домом в кварталах ПИК',
        anchorName: 'Поиграть в мяч у дома',
        imagePath: selectionImages['66'],
      },
      about: {
        title: 'Кварталы с баскетбольными площадками',
        text: 'Новостройки с развитой спортивной инфраструктурой — чтобы играть в мяч около дома',
        imagePath: selectionImages['66'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Выйти во двор и быстро найти баскетбольную площадку — простая задача для тех, кто поселится в новых кварталах ПИК. В своих проектах девелопер создает развитую спортивную инфраструктуру, куда входят оборудованные площадки для игр с мячом',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Игра в баскетбол у дома',
      },
      linkLastCard:
        'https://www.pik.ru/projects?blocks=1688,55,118,464,1372,1519,162,137,156,172,130,477&status=free&utm_source=rbc&utm_medium=display&utm_content=allflats',
    },
    {
      id: '67',
      category: 'location',
      anonce: {
        title: 'Своя терраса в Петербурге ',
        lead: 'Где найти особенную квартиру',
        anchorName: 'Террасы и патио в СПб',
        imagePath: selectionImages['67'],
      },
      about: {
        title: 'Особенные квартиры в Петербурге',
        text: 'В историческом центре города можно найти необычные квартиры с террасой или патио',
        imagePath: selectionImages['67'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'В «Лермонтовском 54» представлены особые квартиры с террасой, где можно любоваться закатами и видом на город. На каждой террасе пол с подогревом. А на первых этажах есть варианты с патио: они выходят в тихий двор и окружены живой изгородью.',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Террасы и патио',
      },
      linkLastCard:
        'https://www.pik.ru/spb/lermontovskiy?utm_source=rbc&utm_medium=display&utm_content=allflats',
      // noBanner: true,
    },
    {
      id: '68',
      category: 'infrastructure',
      anonce: {
        title: 'Что делать детям во дворе',
        lead: 'Батуты, игровые сетки, канаты',
        anchorName: 'Чем заняться детям',
        imagePath: selectionImages['68'],
      },
      about: {
        title: 'Почему детям интересно во дворах ПИК',
        text: 'Взбираться по канату, прыгать на батуте, изучать мир — чем детей привлекает двор',
        imagePath: selectionImages['68'],
      },
      profit: {
        title: <>Почему это важно</>,
        text: 'Позволить ребенку устать и направить его энергию в полезное русло — такова задача-максимум каждой детской площадки. Во дворах-парках кварталов ПИК эту задачу решают с помощью особенной детской инфраструктуры — полезной и при этом безопасной',
        color: '#E3D3F7',
      },
      thematicContent: [
        {
          title: <>Батуты</>,
          image: thematicImages68['1'],
          text: (
            <>
              Небольшие эластичные и&nbsp;сверхпрочные приспособления для
              прыжков и&nbsp;развития координации у&nbsp;детей установят
              во&nbsp;дворах ПИК. Батут может быть отличным инструментом для
              тренировки сердца и&nbsp;улучшения выносливости. А&nbsp;еще
              на&nbsp;батуте весело&nbsp;&mdash; и&nbsp;это главное, что
              привлечет сюда даже самого застенчивого ребенка
            </>
          ),
        },
        {
          title: <>Игровые сетки</>,
          image: thematicImages68['2'],
          text: (
            <>
              Залезть по&nbsp;канату на&nbsp;самый верх или вообразить себя
              супергероем, который передвигается по&nbsp;сетке
              и&nbsp;не&nbsp;может ступить вниз, ведь пол&nbsp;&mdash; это лава.
              Это всего 2&nbsp;сценария из&nbsp;десятков возможных
              на&nbsp;игровых сетках во&nbsp;дворах ПИК. Канатные комплексы
              помогают детям преодолеть страх высоты, развить ловкость
              и&nbsp;силу
            </>
          ),
        },
        {
          title: <>Места для спонтанных игр</>,
          image: thematicImages68['3'],
          text: (
            <>
              Во&nbsp;дворах-парках ПИК также предусмотрены природные уголки,
              где есть разнообразные растения, валдайские валуны и&nbsp;пеньки.
              В&nbsp;таких местах дети могут играть в&nbsp;прятки, прыгать
              по&nbsp;камням и&nbsp;придумывать разнообразные сценарии
              взаимодействия с&nbsp;ландшафтом
            </>
          ),
          url: 'https://www.pik.ru/pages/dvorpark?utm_source=rbc&utm_medium=display&utm_content=blago',
          buttonName: 'Узнать больше',
        },
      ],
    },
    {
      id: '69',
      category: 'location',
      anonce: {
        title: 'Апартаменты для инвестиций',
        lead: 'На набережной в Санкт-Петербурге',
        anchorName: 'Вариант для инвестиций',
        imagePath: selectionImages['69'],
      },
      about: {
        title: 'Апартаменты для инвестора в Петербурге',
        text: 'В апарт-отеле «Вольта» в Северной столице доступны сервисные апартаменты',
        imagePath: selectionImages['69'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'На набережной реки Охта активно строят апарт-отель «Вольта». Все лоты доступны для покупки: инвестор сможет купить помещение площадью от 19 до 39 кв. м и поручить сдачу в аренду и обслуживание профессиональной управляющей компании',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Вариант для инвестиций',
      },
      linkLastCard:
        'https://www.pik.ru/spb/volta?utm_source=rbc&utm_medium=display&utm_content=volta',
      // noBanner: true,
    },
    {
      id: '70',
      anonce: {
        title: 'Проекты «Серии плюс»',
        lead: 'Индивидуальная архитектура',
        anchorName: '«Серия плюс» изнутри',
      },
      about: {
        title: 'Какими оказались квартиры «Серии плюс»',
        text: 'ПИК представил новую линейку домов «Серии плюс». Вот чем они интересны',
        imagePath: selectionImages['70'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'В «Серии плюс» умные планировки, где можно выбрать квартиру с мастер-спальней, с двумя санузлами, просторной кухней-гостиной, гардеробной или постирочной. А еще в таких домах интересная архитектура и дизайнерские лобби с колясочными',
        color: '#e4f0d5',
      },
      tables: {
        title: '«Серия плюс» изнутри',
      },
      linkLastCard:
        'https://www.pik.ru/projects?blocks=1874,1709,518,1108,1580,1129,1196,1124,1541&utm_source=rbc&utm_medium=display&utm_campain=series_plus&utm_content=allflats',
      // noBanner: true,
      disable: true,
    },
    {
      id: '71',
      category: 'location',
      anonce: {
        title: 'Поселиться в Подмосковье',
        lead: 'В квартире по доступной цене',
        anchorName: 'Жилье в Подмосковье',
        imagePath: selectionImages['71'],
      },
      about: {
        title: 'Для чего переезжать в Подмосковье',
        text: 'Здесь доступные цены на жилье, развитая инфраструктура и экологичные районы',
        imagePath: selectionImages['71'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Московская область — редкое место, где сочетается близость к столице и благоприятная экология. Жилье здесь часто выбирают семьи с детьми. Таким семьям особенно важен чистый воздух и возможность купить просторную квартиру по разумной цене',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Жилье в Подмосковье',
      },
      linkLastCard:
        'https://www.pik.ru/search?projects=1&blocks=21,47,294,1272,1220,149,65,1167,296,164,90,156&status=free&utm_source=rbc&utm_medium=display&utm_campain=general&utm_content=allflats',
      // noBanner: true,
    },
    {
      id: '72',
      category: 'infrastructure',
      anonce: {
        title: '8 новых школ и 6 детских садов',
        lead: 'Открылись в кварталах ПИК',
        anchorName: 'Новые школы и детсады',
        imagePath: selectionImages['72'],
      },
      about: {
        title: 'Открылись 8 школ и 6 детских садов',
        text: '11 000 детей начали учебный год в новых школах и детских садах ПИК',
        imagePath: selectionImages['72'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Профессии будущего — главный фокус новых школ. Например, в «Мякинино парке» будут уроки космической робототехники и анализа данных. А в школе «Бунинских лугов» ПИК оборудовал ИТ-полигон с полетной и инженерной зонами для беспилотников',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Новые школы и детские сады',
      },
      linkLastCard:
        'https://www.pik.ru/projects?blocks=519,161,149,1403,90,1200,55,219,65,21&utm_source=rbc&utm_medium=display&utm_campain=general&utm_content=allflats',
      // noBanner: true,
    },
    {
      id: '73',
      category: 'infrastructure',
      anonce: {
        title: 'Детские площадки 2.0',
        lead: 'Игровые зоны нового поколения',
        anchorName: 'Игровые площадки 2.0',
        imagePath: selectionImages['73'],
      },
      about: {
        title: 'Детские площадки нового поколения',
        text: 'В кварталах ПИК открылись игровые зоны с искусственным ручьем и особенным дизайном',
        video: {
          src: '/videos/collection73/1.mp4',
          mutedControl: true,
          topMutedButton: true,
        },
      },
      profit: {
        title: <>Почему это важно</>,
        text: 'В новых кварталах ПИК оборудуют особенные площадки, где можно играть и заниматься спортом. А еще — прикоснуться к природе в собственном дворе. Детские зоны удивят нетипичным оборудованием для игр и продуманной структурой',
        color: '#E3D3F7',
      },
      thematicContent: [
        {
          title: <>Мельница на «Ферме»</>,
          slider: thematicImages73['1'],
          text: (
            <>
              Многие места в&nbsp;Котельниках называются &laquo;Белая
              дача&raquo; в&nbsp;честь усадьбы Аршеневского&nbsp;&mdash;
              а&nbsp;в&nbsp;основу их&nbsp;задумки легла жизнь на&nbsp;природе.
              PlayHub* &laquo;Ферма&raquo; от&nbsp;ПИК поддерживает этот мотив:
              здесь все пропитано духом растениеводства. Детская площадка
              с&nbsp;двухэтажным домиком и&nbsp;горкой получила название
              &laquo;Мельница&raquo;
            </>
          ),
        },
        {
          title: <>Искусственный ручей</>,
          image: thematicImages73['2'],
          text: (
            <>
              Сердце &laquo;Мельницы&raquo;&nbsp;&mdash; искусственный ручей,
              который дети смогут наполнять и&nbsp;осушать. Механизм позволяет
              накачивать воду с&nbsp;помощью помпы и&nbsp;регулировать уровень
              подъемным затвором. С&nbsp;той&nbsp;же целью можно привести
              в&nbsp;движение мельничное колесо &laquo;Наутилус&raquo;
              и&nbsp;поднять на&nbsp;второй этаж наполненные водой ведра
            </>
          ),
        },
        {
          title: <>Навес в форме курицы</>,
          slider: thematicImages73['3'],
          text: (
            <>
              Для самых юных жителей квартала &laquo;Белая Дача парк&raquo; ПИК
              построил песочницу с&nbsp;навесом в&nbsp;форме курицы-мамы
              и&nbsp;качели-балансиры в&nbsp;виде ее&nbsp;детей-цыплят. Также
              здесь есть мини-скалодром, а&nbsp;вокруг песочницы оборудованы
              места для родителей
            </>
          ),
        },
        {
          title: <>Что для взрослых</>,
          image: thematicImages73['4'],
          text: (
            <>
              Взрослым тоже будет чем заняться. К&nbsp;примеру,
              на&nbsp;&laquo;Ферме&raquo; можно отдохнуть в&nbsp;гамаках: здесь
              много зелени, цветов и&nbsp;деревьев с&nbsp;разными периодами
              цветения. Кустарники и&nbsp;многолетние травы создают впечатление
              пребывания на&nbsp;природе: в&nbsp;общественном саду можно
              восстановиться после насыщенного рабочего дня
            </>
          ),
          url: 'https://www.pik.ru/bd?utm_source=rbc',
          buttonName: 'Выбрать квартиру',
        },
        {
          title: <>Сетка над волной</>,
          slider: thematicImages73['5'],
          text: (
            <>
              Самая интересная деталь площадки Local Play*** в&nbsp;квартале
              &laquo;Большая Академическая&nbsp;85&raquo;&nbsp;&mdash; это
              высокая асимметричная волна, с&nbsp;которой можно весело съезжать
              по&nbsp;трехметровой горке. Пространство вокруг покрыто песком,
              а&nbsp;над самой волной натянута сетка для лазанья. Внутри
              обустроен скалодром
            </>
          ),
          url: 'https://www.pik.ru/ba85?utm_source=rbc',
          buttonName: 'Выбрать квартиру',
        },
        {
          title: <>Комнаты на воздухе и под крышей</>,
          slider: thematicImages73['6'],
          text: (
            <>
              MultiHub** &laquo;Румс&raquo; в&nbsp;составе квартала
              &laquo;Плеханова&nbsp;11&raquo; разобьют
              на&nbsp;&laquo;комнаты&raquo;, отделенные живой изгородью. Каждая
              &laquo;комната&raquo; предназначена для детей определенного
              возраста. Самой крупной станет &laquo;Спрятанный город&raquo;,
              куда войдут несколько башен. А&nbsp;под навесом обустроят
              &laquo;Комнату настольных игр&raquo;
            </>
          ),
          url: 'https://www.pik.ru/plehanova11?utm_source=rbc',
          buttonName: 'Выбрать квартиру',
        },
        {
          title: <>Акведук во дворе</>,
          slider: thematicImages73['7'],
          text: (
            <>
              Точкой притяжения Мытищ обещает стать PlayHub*
              &laquo;Акведук&raquo; в&nbsp;проекте &laquo;Ярославский&raquo;.
              С&nbsp;двух сторон ее&nbsp;будут обрамлять два акведука
              с&nbsp;башней, игровой палубой, песочницей и&nbsp;трапом.
              А&nbsp;самым высоким объектом станет водонапорная башня
              с&nbsp;флюгером, тремя уровнями сеток и&nbsp;наблюдательным
              пунктом на&nbsp;самом верху
            </>
          ),
          url: 'https://www.pik.ru/zhiloi-raion-yaroslavskii?utm_source=rbc',
          buttonName: 'Выбрать квартиру',
        },
        {
          title: <>Яблоневый сад</>,
          slider: thematicImages73['8'],
          text: (
            <>
              Во&nbsp;дворе квартала &laquo;Второй Нагатинский&raquo; откроется
              MultiHub** &laquo;Яблони&raquo;, где будет садовое кафе
              с&nbsp;летней площадкой и&nbsp;уютной нишей в&nbsp;стене.
              Отличительной особенностью детской зоны станет большая песочница
              с&nbsp;холмами для игр под круглым навесом с&nbsp;качелями. Рядом
              протянется спортивный бульвар
            </>
          ),
          url: 'https://www.pik.ru/2ngt?utm_source=rbc',
          buttonName: 'Выбрать квартиру',
        },
        {
          title: <>Зиплайн и скейт-парк</>,
          slider: thematicImages73['9'],
          text: (
            <>
              Собственный скейт-парк с&nbsp;виражами и&nbsp;подъемами оборудуют
              в&nbsp;&laquo;Сигнальном&nbsp;16&raquo;. Любители активного отдыха
              оценят и&nbsp;уличные тренажеры с&nbsp;площадкой для стритбола.
              В&nbsp;игровой зоне MultiHub** &laquo;Сигнал&raquo; маленьких
              жителей ждет канатная сеть, стальной купол, тоннель
              и&nbsp;31-метровый зиплайн
            </>
          ),
          url: 'https://www.pik.ru/s16?utm_source=rbc',
          buttonName: 'Выбрать квартиру',
        },
      ],
      footnote:
        '*PlayHub («плейхаб») — в переводе с английского «игровая зона»<br>**MultiHub («мультихаб») — слово не имеет перевода на русский и может считаться неологизмом, который обозначает общественное пространство, сочетающее несколько функций, среди которых могут быть игра, спорт, отдых и другие<br>***Local Play («Локал Плей») — в переводе с английского «играть поблизости»',
    },
    {
      id: '74',
      category: 'popular',
      anonce: {
        title: 'Квартиры с выгодой до 2 млн ',
        lead: 'По Семейной ипотеке',
        anchorName: 'Выгодные квартиры',
        imagePath: selectionImages['74'],
      },
      about: {
        title: 'Семейная ипотека',
        text: 'На каких условиях семьи с детьми могут купить жилье в новостройке в 2025 году',
        imagePath: selectionImages['74'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Ставка по Семейной ипотеке ПИК ниже, чем по стандартной семейной ипотеке. Это возможность для семей с детьми купить квартиру по низкой ставке и зафиксировать ее на весь срок',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Выгодные квартиры',
      },
      linkLastCard:
        'https://www.pik.ru/search?projects=1&currentBenefit=semejnaya-ipoteka-4-1&utm_siurce=rbc',
      // noBanner: true,
      bannerNumber: 74,
      disable: true,
    },
    {
      id: '75',
      category: 'popular',
      anonce: {
        title: 'Готовые квартиры с выгодой',
        lead: 'Ключи сразу после покупки',
        anchorName: 'Готовые квартиры',
        imagePath: selectionImages['75'],
      },
      about: {
        title: 'Готовые квартиры с выгодой до 4,5 млн ₽',
        text: 'ПИК представил особые условия покупки для квартир в 41 готовом квартале в Москве',
        imagePath: selectionImages['75'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Готовая квартира в новостройке — предложение, которое встречается не так часто. Здесь можно получить ключи сразу после покупки и быстро переехать — останется только купить мебель и навести уют. У ПИК есть варианты на особых условиях',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Готовые квартиры',
      },
      linkLastCard: 'https://www.pik.ru/search/ready?projects=1&utm_source=rbc',
      // noBanner: true,
      // disable: true,
    },
    {
      id: '76',
      category: 'infrastructure',
      anonce: {
        title: 'Помещения с арендаторами',
        lead: 'Готовый бизнес в новостройке',
        anchorName: 'Арендный бизнес',
        imagePath: selectionImages['76'],
      },
      about: {
        title: 'Коммерческие помещения с арендаторами',
        text: 'В проектах ПИК можно купить готовый арендный бизнес. Это объекты на первых этажах',
        imagePath: selectionImages['76'],
      },
      profit: {
        title: <>Почему это важно</>,
        text: 'В кварталах ПИК есть редкая возможность купить коммерческие помещения с арендаторами: в таких объектах уже заключены договоры аренды. Такая недвижимость способна приносить доход с первого дня',
        color: '#E3D3F7',
      },
      thematicContent: [
        {
          title: <>Простота управления</>,
          image: thematicImages76['1'],
          text: (
            <>
              В&nbsp;отличие от&nbsp;большинства типов бизнеса, где важно
              разобраться в&nbsp;новой отрасли, деятельность рантье максимально
              проста для новичков. А&nbsp;если купить помещение с&nbsp;уже
              подписанным контрактом на&nbsp;аренду, то&nbsp;можно избежать
              сложностей при составлении договора. Организационные моменты здесь
              решены заранее
            </>
          ),
        },
        {
          title: <>Индексация ставок</>,
          image: thematicImages76['2'],
          text: (
            <>
              Контракты с&nbsp;арендаторами заключаются на&nbsp;много лет
              и&nbsp;предусматривают ежегодную индексацию ставок, то&nbsp;есть
              регулярное повышение стоимости аренды. Это позволяет идти вровень
              с&nbsp;доходностью депозитов и&nbsp;защититься от&nbsp;инфляции:
              выручка сможет расти одновременно со&nbsp;сроком владения объектом
            </>
          ),
        },
        {
          title: <>Предсказуемый доход</>,
          image: thematicImages76['3'],
          text: (
            <>
              Магазины, банки и&nbsp;салоны красоты не&nbsp;привыкли переезжать:
              для них важно, чтобы клиент знал определенный адрес
              и&nbsp;постоянно туда возвращался. Это делает торговые сети, кафе
              и&nbsp;рестораны идеальными арендаторами: они склонны вести себя
              максимально предсказуемо, оставаясь в&nbsp;одном помещении десятки
              лет
            </>
          ),
        },
        {
          title: <>Высокая ликвидность</>,
          image: thematicImages76['4'],
          text: (
            <>
              В&nbsp;условиях масштабного строительства, которое развернул ПИК,
              потребность жителей новых кварталов в&nbsp;магазинах
              и&nbsp;салонах красоты останется стабильно высокой на&nbsp;годы
              вперед. Это делает помещения на&nbsp;первых этажах
              высоколиквидными: в&nbsp;долгосрочной перспективе спрос
              на&nbsp;такие объекты предсказуемо высок
            </>
          ),
        },
        {
          title: <>Защита от экономических потрясений</>,
          image: thematicImages76['5'],
          text: (
            <>
              Альтернативой покупке готового арендного бизнеса могли&nbsp;бы
              стать инвестиции на&nbsp;фондовом рынке. Однако это
              не&nbsp;защитит от&nbsp;возможных обвалов на&nbsp;рынке
              и&nbsp;колебаний курса. Те&nbsp;же риски есть
              и&nbsp;у&nbsp;сбережений в&nbsp;валюте. Недвижимость защищена
              от&nbsp;внешних шоков тем, что ее&nbsp;цена остается более
              предсказуемой
            </>
          ),
        },
        {
          title: <>Широкий выбор</>,
          image: thematicImages76['6'],
          text: (
            <>
              В&nbsp;кварталах ПИК можно найти как скромные помещения площадью
              25&nbsp;кв.&nbsp;м&nbsp;с&nbsp;кофейнями и&nbsp;цветочными
              магазинами, так и&nbsp;обширные объекты
              на&nbsp;2&nbsp;тыс.&nbsp;кв.&nbsp;м, где может быть размещен
              фитнес-центр. Есть и&nbsp;средние варианты
              на&nbsp;150&mdash;500&nbsp;кв.&nbsp;м: здесь площади арендуют
              сетевые магазины и&nbsp;кафе
            </>
          ),
          url: 'https://www.pik.ru/business/search/rentBusiness?projects=1&utm_source=rbc',
          buttonName: 'Узнать больше',
        },
      ],
      // disable: true,
    },
    {
      id: '77',
      anonce: {
        title: 'Готовые квартиры от ₽19 600 в месяц',
        lead: 'Ипотека по низкой ставке',
        anchorName: 'От ₽19 600 в месяц',
      },
      about: {
        title: 'Готовые квартиры по низкой ставке',
        text: 'В Москве и области можно купить жилье в ипотеку с платежом от ₽19 600 в месяц',
        imagePath: selectionImages['77'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Благодаря льготным программам в жилых кварталах ПИК можно найти привлекательные варианты жилья. Это готовые квартиры в сданных домах. При покупке в ипотеку на срок до 30 лет и взносом от 20,01% платеж начинается с ₽19 600 в месяц',
        color: '#e4f0d5',
      },
      tables: {
        title: 'От ₽19 600 в месяц',
      },
      linkLastCard:
        'https://www.pik.ru/search?projects=1&requiredTags=gotovoe&utm_source=rbc',
      // noBanner: true,
      bannerNumber: 77,
      disable: true,
    },
    {
      id: '78',
      category: 'popular',
      anonce: {
        title: 'Готовые квартиры',
        lead: 'Варианты с техникой и мебелью',
        anchorName: 'Квартиры с мебелью',
        imagePath: selectionImages['78'],
      },
      about: {
        title: 'Где найти готовые квартиры с мебелью',
        text: 'В кварталах ПИК продается жилье с встроенной техникой и кухонным гарнитуром',
        imagePath: selectionImages['78'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Готовые к переезду квартиры можно найти в двух кварталах. Мебель подобрана в соответствии с планировкой, чтобы идеально вписаться в габариты, а цветовые решения сочетаются с готовой отделкой ПИК',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Квартиры с мебелью',
      },
      linkLastCard:
        'https://www.pik.ru/search?projects=1&status=free&hasFinish=3&utm_source=rbc',
      // noBanner: true,
      // disable: true,
    },
    {
      id: '79',
      type: 'commercial',
      category: 'infrastructure',
      anonce: {
        title: 'Коммерческие помещения',
        lead: 'Сдать в аренду и зарабатывать',
        anchorName: 'Помещения для бизнеса',
        imagePath: selectionImages['79'],
      },
      about: {
        title: 'Готовые помещения для бизнеса',
        text: 'Покупка коммерческой недвижимости в новостройке поможет зарабатывать на аренде',
        imagePath: selectionImages['79'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Покупка готового помещения — быстрый путь к получению пассивного дохода. Как только собственник получает ключи, арендатор может приступать к ремонту, чтобы как можно скорее открыть бизнес. А потенциальные клиенты уже живут в том же квартале',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Помещения для бизнеса',
      },
      linkLastCard:
        'https://www.pik.ru/business/search?projects=1&blocks=156,1688,1541,55,1369,119,1519,161,1460&ready=1&utm_source=rbc',
      // noBanner: true,
    },
    {
      id: '80',
      category: 'location',
      anonce: {
        title: '«Москворечье»: новые дома',
        lead: 'Начались продажи видовых квартир',
        anchorName: 'Корпуса «Москворечья»',
        imagePath: selectionImages['80'],
      },
      about: {
        title: '«Москворечье»: новый уровень комфорта',
        text: 'В высотных корпусах нового проекта ПИК начались продажи видовых квартир',
        imagePath: selectionImages['80'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Вся угловая часть одного корпуса «Москворечья» получит панорамное остекление. Это откроет удивительный вид на город. Окна другого дома выйдут на пешеходный бульвар, чтобы жители смогли наблюдать, как их дети гуляют и катаются на роликах',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Корпуса «Москворечья»',
      },
      linkLastCard:
        'https://www.pik.ru/search/moskvorechye?bulk=10437,10436&utm_source=rbc',
      // noBanner: true,
    },
    {
      id: '81',
      category: 'popular',
      anonce: {
        title: 'Видовые квартиры ПИК',
        lead: 'В зеленых районах Москвы',
        anchorName: 'Видовые квартиры',
        imagePath: selectionImages['81'],
      },
      about: {
        title: 'Где найти видовую квартиру в Москве',
        text: 'Подобрать жилье с видом на лес, реку или достопримечательности можно в проекте ПИК',
        imagePath: selectionImages['81'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'В жилых кварталах ПИК можно найти по-настоящему особенные квартиры: с видом на лес, Москву-реку или старый город. В подборке собраны московские проекты ПИК с красивыми видами',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Видовые квартиры',
      },
      linkLastCard:
        'https://www.pik.ru/search?projects=1&optionGroups=view&utm_source=rbc',
      // noBanner: true,
      // disable: true,
    },
    {
      id: '82',
      type: 'commercial',
      category: 'infrastructure',
      anonce: {
        title: 'Высоколиквидные помещения',
        lead: 'В Петербурге на первых этажах',
        anchorName: 'Коммерческие помещения',
        imagePath: selectionImages['82'],
      },
      about: {
        title: 'Высоколиквидные помещения в Петербурге',
        text: 'Где найти интересные варианты для размещения бизнеса на первых этажах новостроек',
        imagePath: selectionImages['82'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Высоколиквидные помещения — это коммерческие лоты до 100 кв. м в кварталах ПИК с высоким пешеходным и автомобильным трафиком. Они максимально адаптивны под любой тип бизнеса: магазины, кафе, рестораны, пункты выдачи заказов и многое другое',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Коммерческие помещения',
      },
      linkLastCard:
        'https://www.pik.ru/business/spb/search?projects=1&utm_source=rbc',
      // noBanner: true,
    },
    {
      id: '83',
      category: 'popular',
      anonce: {
        title: 'Как меняется восток Москвы',
        lead: 'С новыми кварталами ПИК',
        anchorName: 'Квартиры в ВАО',
        imagePath: selectionImages['83'],
      },
      about: {
        title: 'Как преображается восток Москвы',
        text: 'Как ПИК меняет облик Москвы: изучаем на примере кварталов «Серии Плюс» в ВАО',
        imagePath: selectionImages['83'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Восточный округ Москвы считался индустриальной зоной, однако новые кварталы ПИК с выразительной архитектурой меняют это восприятие. Проекты «2-й Иртышский» и «Плеханова 11» станут яркими акцентами в обновленном ВАО',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Выбрать квартиру',
      },
      linkLastCard:
        'https://www.pik.ru/search?projects=1&blocks=1709,1580&utm_source=rbc',
      // noBanner: true,
    },
    {
      id: '84',
      category: 'location',
      anonce: {
        title: '«Саларьево Парк»: новые корпуса',
        lead: 'Редкий шанс выгодной покупки',
        anchorName: '«Саларьево Парк»',
        imagePath: selectionImages['84'],
      },
      about: {
        title: 'Новые квартиры в «Саларьево парке»',
        text: 'Открылись продажи в корпусе у метро с особенно выгодными ценами',
        imagePath: selectionImages['84'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'ПИК начал продажи в новом корпусе «Саларьево Парка» в пешей доступности от двух станций метро. Здесь можно купить светлую квартиру с большими окнами, балконами, умной планировкой и отделкой на выбор',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Выбрать квартиру',
      },
      linkLastCard: 'https://www.pik.ru/search/sp?utm_source=rbc',
      // noBanner: true,
    },
    {
      id: '85',
      category: 'popular',
      anonce: {
        title: 'Новые квартиры с ремонтом',
        lead: 'В перспективных районах Москвы',
        anchorName: 'Квартиры с выгодой',
        imagePath: selectionImages['85'],
      },
      about: {
        title: 'Квартиры в развивающихся районах',
        text: 'Где выгодно купить квартиру с ремонтом в Москве и области',
        imagePath: selectionImages['85'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Все квартиры из подборки находятся в проектах с готовой или строящейся инфраструктурой. К моменту переезда рядом с новыми домами появятся магазины, школы и все, что нужно для жизни. Цены на квартиры при этом еще не успели вырасти',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Квартиры с выгодой',
      },
      linkLastCard:
        'https://www.pik.ru/projects?blocks=1272,1220,156,118&new=1&utm_source=rbc',
      // noBanner: true,
    },
    {
      id: '86',
      anonce: {
        title: 'Заселиться до конца года',
        lead: 'В готовую квартиру ПИК',
        anchorName: 'Заселение в 2024 году',
        imagePath: selectionImages['86'],
      },
      about: {
        title: 'Новый год в новой квартире',
        text: 'Специальные цены на готовые квартиры до 31 декабря',
        imagePath: selectionImages['86'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Готовые кварталы подойдут тем, кто хочет переехать прямо сейчас и встретить Новый год в новой квартире. На предложения в этой подборке действуют специальные цены до 31 декабря 2024 года',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Выбрать квартиру',
      },
      linkLastCard:
        'https://www.pik.ru/search/ready?projects=1&requiredTags=specialprice&utm_source=rbc',
      // noBanner: true,
      disable: true,
    },
    {
      id: '87',
      category: 'location',
      anonce: {
        title: 'Кварталы у лыжных склонов',
        lead: 'Где поселиться любителям спорта',
        anchorName: 'У горнолыжных трасс',
        imagePath: selectionImages['87'],
      },
      about: {
        title: 'Где поселиться любителям горных лыж',
        text: 'Около проектов ПИК можно найти не только привычные удобства, но даже лыжную трассу',
        imagePath: selectionImages['87'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Зимний спорт может быть ближе, чем кажется. В этой подборке собраны кварталы ПИК, жителям которых не нужно долго ехать за город, чтобы покататься на лыжах или сноуборде: горнолыжные комплексы находятся рядом с домом',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Выбрать квартиру',
      },
      linkLastCard: 'https://www.pik.ru/projects?utm_source=rbc',
      // noBanner: true,
    },
    {
      id: '88',
      category: 'popular',
      anonce: {
        title: 'Квартиры «Серии Плюс»',
        lead: 'С продуманными планировками',
        anchorName: 'Квартиры «Серии Плюс»',
        imagePath: selectionImages['88'],
      },
      about: {
        title: 'Квартиры в новых корпусах «Серии Плюс»',
        text: 'В домах с выразительной архитектурой и функциональными планировками',
        video: {
          src: '/videos/collection88/collection-88.mp4',
        },
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Дома «Серии плюс» отличаются продуманной архитектурой от известных бюро. В квартирах – умные планировки, высокие потолки, большие окна. Можно выбрать необычный вариант с эркером или угловым балконом. Старт продаж – выгодный момент для покупки',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Выбрать квартиру',
      },
      linkLastCard:
        'https://www.pik.ru/projects?blocks=1421,1108,1709&new=1&utm_source=rbc',
      // noBanner: true,
    },
    {
      id: '89',
      category: 'popular',
      anonce: {
        title: 'Семейная ипотека',
        lead: 'Какие варианты доступны в 2025-м',
        anchorName: 'Семейная ипотека 2025',
        imagePath: selectionImages['89'],
      },
      about: {
        title: 'Квартиры от ₽22 000 в месяц',
        text: 'На каких условиях семьи с детьми могут купить жилье в новостройке в 2025 году',
        imagePath: selectionImages['89'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Приобрести квартиру в готовом или строящемся доме можно с фиксированной ставкой 5,99% и ежемесячным платежом: от ₽29 тыс. в Москве и от ₽22 тыс. в Московской области. Особенно подойдет тем, кому важно переехать сразу после покупки',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Выбрать квартиру',
      },
      linkLastCard:
        'https://www.pik.ru/search?projects=1&currentBenefit=semejnaya-ipoteka-5-99-3&utm_source=rbc',
      // noBanner: true,
      bannerNumber: 74,
    },
    {
      id: '90',
      category: 'infrastructure',
      anonce: {
        title: 'Кварталы, где все устроено',
        lead: 'Заселиться и радоваться жизни',
        anchorName: 'Готовая инфраструктура',
        imagePath: selectionImages['90'],
      },
      about: {
        title: 'Кварталы с готовой инфраструктурой',
        text: 'Здесь школы, детсады, поликлиники, магазины и кафе уже построены и работают',
        imagePath: selectionImages['90'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Переехать и сразу пользоваться удобствами: отправить детей в школу или детсад, прикрепиться к поликлинике, по утрам завтракать в кофейне на первом этаже. Так устроен быт тех, кто поселился в одном из кварталов ПИК с готовой инфраструктурой',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Выбрать квартиру',
      },
      linkLastCard:
        'https://www.pik.ru/projects?blocks=294,21,156,161 (https://www.pik.ru/projects?blocks=294,21,156,161&utm_source=rbc)&utm_source=rbc (https://www.pik.ru/projects?blocks=294,21,156,161&utm_source=rbc)',
      // noBanner: true,
    },
    {
      id: '91',
      type: 'commercial',
      category: 'popular',
      anonce: {
        title: 'Коммерческие помещения',
        lead: 'Подойдут для магазина и кафе',
        anchorName: 'Помещения для бизнеса',
        imagePath: selectionImages['91'],
      },
      about: {
        title: 'Удобные помещения для бизнеса',
        text: 'Варианты с гибкими планировками: здесь можно объединить или разделить пространство',
        imagePath: selectionImages['91'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Ключевое преимущество объектов площадью от 100 до 200 кв. м — универсальность. Такие помещения можно сдать целиком, чтобы внутри открыть магазин, офис или ресторан. А можно разделить, чтобы найти нескольких арендаторов',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Выбрать помещение',
      },
      linkLastCard:
        'https://www.pik.ru/business/search?projects=1&ready=1&utm_source=rbc',
      // noBanner: true,
    },
    {
      id: '92',
      category: 'location',
      anonce: {
        title: 'Кварталы ПИК на юге Москвы',
        lead: 'В экологичных районах столицы',
        anchorName: 'Дома на юге Москвы',
        imagePath: selectionImages['92'],
      },
      about: {
        title: (
          <span className='title--is-small'>
            Гармония природы и&nbsp;комфорт мегаполиса
          </span>
        ),
        text: 'Кварталы ПИК на юге Москвы с хорошей транспортной доступностью в развитых районах',
        imagePath: selectionImages['92'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: (
          <>
            На&nbsp;юге Москвы чистый воздух и&nbsp;много парков, включая&nbsp;
            <br className='for-desktop'></br>музеи-заповедники
            &laquo;Коломенское&raquo; и&nbsp;Царицыно. От&nbsp;кварталов ПИК
            до&nbsp;центра легко добраться на&nbsp;метро, МЦД или автомобиле.
            А&nbsp;рядом с&nbsp;домами есть детсады, школы, поликлиники
            и&nbsp;торговые центры
          </>
        ),
        color: '#e4f0d5',
      },
      tables: {
        title: 'Выбрать квартиру',
      },
      linkLastCard:
        'https://www.pik.ru/projects?blocks=1421,1874,1369&utm_source=rbc',
    },
    {
      id: '93',
      category: 'popular',
      anonce: {
        title: 'Куда инвестировать в 2025',
        lead: 'Кварталы, которые скоро достроят',
        anchorName: 'Инвестировать в 2025',
        imagePath: selectionImages['93'],
      },
      about: {
        title: 'Куда логично инвестировать в 2025 году',
        text: 'Квартиры будут готовы в течение года — а значит, скоро смогут приносить доход',
        imagePath: selectionImages['93'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Подборка для тех, кто хочет выгодно вложить или сохранить сбережения. Здесь собраны квартиры в московских и петербургских проектах ПИК, которые достроят до конца года. Такие квартиры можно оперативно сдать в аренду и начать зарабатывать',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Выбрать квартиру',
      },
      linkLastCard:
        'https://www.pik.ru/projects?blocks=1556,296,294,378,118,1421&utm_source=rbc',
    },
    {
      id: '94',
      anonce: {
        title: 'Квартиры для инвестиций',
        lead: 'По выгодным ценам. Старт продаж',
        anchorName: 'Квартиры для инвестора',
        imagePath: selectionImages['94'],
      },
      about: {
        title: 'Квартиры для выгодных инвестиций',
        text: 'В новых корпусах ПИК открылись продажи квартир по привлекательным ценам',
        imagePath: selectionImages['94'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Старт продаж — это возможность приобрести недвижимость по выгодной цене по сравнению с более поздними этапами строительства. В будущем покупатели таких квартир смогут получить максимальную выгоду от развития проекта',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Выбрать квартиру',
      },
      linkLastCard: 'https://www.pik.ru/projects?new=1&utm_source=rbc',
    },
    {
      id: '95',
      type: 'commercial',
      anonce: {
        title: 'Помещения в готовых домах',
        lead: 'Для бизнеса или сдачи в аренду',
        anchorName: 'Коммерческие помещения',
        imagePath: selectionImages['95'],
      },
      about: {
        title: 'Коммерческие помещения в готовых домах',
        text: 'Такие площади можно сразу сдавать в аренду или открыть бизнес самостоятельно',
        imagePath: selectionImages['95'],
      },
      profit: {
        title: <>Почему это интересно</>,
        text: 'Купить коммерческую площадь в готовом доме — значит получить актив, который сможет сразу приносить прибыль. Помещение можно быстро сдать в аренду или запустить свой бизнес. Клиентский трафик уже сформирован, так как дом заселен',
        color: '#e4f0d5',
      },
      tables: {
        title: 'Выбрать помещение',
      },
      linkLastCard: '',
    },
    // {
    //   id: '//',
    //   about: {
    //     title: '///',
    //     text: '///',
    //     imagePath: selectionImages['31'],
    //   },
    //   profit: {
    //     title: <>///</>,
    //     text: '///',
    //     color: '#e4f0d5   #E3D3F7',
    //   },
    // thematicContent: [
    //   {
    //     title: (
    //       <>
    //         ///
    //       </>
    //     ),
    //     image: selectionImagesTop['2'],
    //     text: (
    //       <>
    //        ///
    //       </>
    //     ),
    //     url: '///',
    //     urlInner: true, // если ссылка на внутренние страницы
    //     buttonName: '///',
    //   },
    // ]
    //   tables: { // если таблица в подборке не должна быть то это поле удаляем (обычно в контентных подборках с тематическими блоками)
    //     title: '///',
    //   },
    //  noMetro: true, если квартиры в городах где нет метро (это поле обычно должно быть удалено)
    //  disable: true, если надо скрыть
    //  linkLastCard: ссылка на последнюю карточку в подборке
    // },
  ],
}

export const weekSelection =
  collectionsData.collections[collectionsData.collections.length - 1]
